/* eslint-disable import/named */
import {
  fetchDetailQuestionBank,
  getDDLDepartmentApi,
  getDDLDivisionApi,
  getDDLQuestionDepartmentApi,
  getDDLQuestionGroupsApi,
  getDDLQuestionLevelsApi,
  getDDLQuestionRegionApi,
  getDDLQuestionTypesApi,
  getDDLQuestionUnitsApi,
  getDDLQuestionUsersApi,
  getDDLRestaurantApi,
  CheckQuestion360Exist,
  getDDLRegionGroupApi,
  getDDLUnitGroupApi,
  getDDLDepartmentGroupApi,
  getDDLDivisionGroupApi,
  getDDLRestaurantGroupApi,
  getDDLPositionGroupApi,
  getDDLLevelGroupApi,
  deleteQuestion360,
} from 'api/questionBankAPI';
import {
  createLinkSurvey,
  get360SurveyMembersListApi,
  getDdlEmbedAppApi,
  getDDLResultUserApi,
  getDetailGroupApi,
  getDetailMemberListApi,
  getDetailSurveyApi,
  getNumberPeopleDoNotSurvey,
  getSurveyQuestionByID,
  getSurveyResults,
  getSurveyTotalStatistics,
  postSurveyAddQuestionApi,
  postSurveyInformationApi,
  postSurveyStaffs,
  updateSurveyAddQuestionApi,
  updateSurveyInfomationApi,
  updateSurveyMemberListAllCompanyApi,
  updateSurveyMemberListGroupApi,
  updateSurveyMemberListUserApi,
  getInformationSurvey,
  getSurveyViewers,
  getSurveyDepartments,
  getSurveyObject360,
  getSurveyApps,
  getFilterSurvey,
} from 'api/surveyApi';
import {
  ERROR_BONUS_CODE,
  SUCCESS_ADD_CONTENT,
  SUCCESS_EDIT_CONTENT,
  ERROR_NOT_COMPLETED_EVALUATED_QUESTION,
  SURVEY_NOT_FOUND,
} from 'constant/textNotification';
import dayjs, { Dayjs } from 'dayjs';
import useHandleError from 'hooks/useHandleError';
import useToastNotification from 'hooks/useToastNotification';
import isEqual from 'lodash/isEqual';
import once from 'lodash/once';
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react';
import { useLocation, useNavigate } from 'react-router';
import { cachingFnc } from 'utils/caching-helper';
import { CombineTypeAnswer, mappingSelectType } from 'views/pages/questionBank/questionAdd/types';
import {
  DdlDepartment,
  DdlIEmbedApp,
  DdlLevel,
  DdlQuestionDepartment,
  DdlQuestionGroups,
  DdlQuestionPosition,
  DdlQuestionTypes,
  DdlQuestionUnit,
  DdlQuestionUsers,
  DdlRegion,
  IDetailQuestionBank,
} from 'views/pages/questionBank/type';
import {
  defaultQuestionEvaluated,
  defaultQuestionEvaluatedWhenUpdateQuestion,
  defaultSurveyInformation,
  defaultListOfBonusCode,
  surveyMemberGroupFilterDefault,
  defaultMemberGroupInfo,
  defaultLoadingMemberGroupInfo,
  surveyTypeConstant,
  defaultParamFiltersEvaluatedQuestion,
  actionUpdateStaffsConstant,
  surveyFormConstant,
  surveyAppIDConstant,
} from '../const';
import {
  DdlGroupDivision,
  DdlGroupRestaurant,
  DdlOutlook,
  I360MemberList,
  IGetSurveyMemberGroupFilter,
  IGetSurveyMemberList,
  IGetSurveyMemberSearch,
  SurveyMemberListSelectedType,
  IObjectGroupIDsDetails,
  ISurveyGroupAddList,
} from '../surveyAdd/ListOfMembers/types';
import {
  IDepartment,
  IGetSurveyInfomation,
  IList,
  IListOfBonusCode,
  IParentQuestions,
  ISetSurveyInfomation,
  ISingleQuestionReport,
  ISurveyAddQuestion,
  ISurveyDepartment,
  ISurveyQuestions,
  ISurveyStaff,
  ISurveyTotalStatistics,
  ISurveyUserReview,
  SurveyTypes,
  TSelectType,
  ISurveySingleQuestion,
  IMemberGroupInfo,
  ILoadingMemberGroupInfo,
  TActionChangeListMemberGroup,
  ISurveyViewers,
  IParamFilterEvaluatedQuestionProps,
  ISurveyUser,
} from '../surveyAdd/type';
import { ISectionGroup, ModalTypes, objectSurveyPeopleByNumber, ISurveyDataSave } from '../type';
import { ActionTypes } from './actions';
import reducer from './reducer';
import {
  handleGetUSerID,
  findQuestionArrByField,
  generateArrayString,
  getInfoUserAuth,
} from 'utils/helperFunctions';
import { uploadExcelListOfBonusApi } from 'api/campaign';
import { IUploadExcelCallApi } from '../surveyAdd/ListOfMembers/Component/Excel/UploadExcelModal';

import { ICopySurveyState } from 'views/pages/survey/type';
import {
  memberGroupRequest,
  TypeSelectedOption,
  allOptionUserViewer,
} from 'views/pages/survey/const';
import { helperFormatDataForCallAPI } from '../surveyAdd/ListOfMembers/ListMemberGroup/helperHandleData';
import list360 from './sample';
import { maxRecordLength } from 'views/pages/survey/surveyAdd/ListOfMembers/ListMemberUser/utils/defaultDataTable';
import { TConditionSelectGroup, IDDLCategory } from 'views/pages/survey/surveyAdd/type';
import { SURVEY_LIST_PATH, ROOT, SURVEY_EDIT, SURVEY_ADD, SURVEY_VIEW } from 'constant/path';
import { createSearchParams } from 'react-router-dom';
import useDuplicateStaffConflictModal from '../surveyAdd/hooks/useDuplicateStaffConflictModal';
import { handleDuplicateStaffConflictForApp, TUpdateInfoError } from './duplicateStaffConflict';
import { isOrgUnitMemberSurvey } from '../surveyAdd/ListOfMembers/OrgUnitMember/utils';
import { runOrgUnitMemberSave } from '../surveyAdd/ListOfMembers/OrgUnitMember/orgUnitMemberBridge';

export enum SurveyConst {
  INIT_GROUP_QUESTION = 'INIT_GROUP_QUESTION',
  START_INIT = 'START_INIT',
  END_INIT = 'END_INIT',
  LOADING_ON = 'LOADING_ON',
  LOADING_OFF = 'LOADING_OFF',
  CUSTOMER_INFO = 'CUSTOMER_INFO',
  EMPLOYEE_INFO = 'EMPLOYEE_INFO',
  SURVEY = 'SURVEY',
}

interface ISurveyProvider {
  children: React.ReactNode;
}

export type InitialStateType = {
  // Common Use
  isSaveAllTabs: boolean;
  isLoading: boolean;
  // statics
  isOpenModalPerson: boolean;
  isOpenModalQuestion: boolean;
  isOpenModalQuestionUserEvaluated: boolean;
  isOpenModalSection: boolean;
  isOpenModalConfirm: boolean;
  isOpenModalLockSurvey: boolean;
  isOpenModalPublishSurvey: boolean;
  isOpenModalDraftSurvey: boolean;
  isOpenModalUploadSurvey: boolean;
  isOpenModalConfirmShowSurveyResults: boolean;
  isOpenModalDeleteQuestionUsedSurvey: boolean;
  isOpenModalConfirmExitEditSurvey: boolean;
  isOpenModalUploadEvaluatedPeople360: boolean;
  isPersonInfoDisplayed: boolean;
  isDisabledSurveyEdit: boolean;
  isViewSurvey: boolean;
  /** Đang mở bằng đường dẫn Xem (không tính chế độ chỉ xem do khóa chỉnh sửa) */
  isViewRoute: boolean;
  employeeInfoDisplayed: { [key: string]: boolean };
  customerInfoDisplayed: { [key: string]: boolean };
  groupQuestions: ISectionGroup | null;
  selectQuestionID: string;
  selectSectionID: string;
  memberObjectGroup: number;
  surveyInformation: IGetSurveyInfomation;
  listOfBonusCode: IUploadExcelCallApi;
  surveyMemberSearch: IGetSurveyMemberSearch;
  surveyMemberGroupFilter: IGetSurveyMemberGroupFilter;
  surveyMemberList: any;
  surveyMemberListAll: any;
  surveyMemberList360: any;
  surveyMemberListAll360: any;
  surveyMemberListSelected: SurveyMemberListSelectedType[];
  surveyMemberListChosen: any[];
  currentTab: TSelectType;
  previousTab: TSelectType;
  isInitSurvey: boolean;
  skipModalConfirm: boolean; // -> using skip open modal confirm
  isUserChangeModalAddQuestion: boolean;
  isCopySurvey: boolean;
  infoPeople: string;
  disabledSurvey360: boolean;
  surveyTypeForm: number;
  questionIDArrCopy: string[];
  surveyDataSaveTab: ISurveyDataSave;
  isEvaluatedQuestionExist: boolean;
  questionOrder: string;
  memberGroupInfo: IMemberGroupInfo;
  loadingMemberGroupInfo: ILoadingMemberGroupInfo;
  typeActionChangeListMemberGroup: TActionChangeListMemberGroup;
  currentValueInformationTab: IGetSurveyInfomation;
  listStaff360: IDDLCategory[];
  isFetchQuestionAfterUploadExcel: boolean; //if upload question success -> fetch question form DB
  isFirstLoadTab: { [x: string]: boolean };
  paramFiltersEvaluatedQuestion: IParamFilterEvaluatedQuestionProps;
  isMemberList360Changed: boolean; //used for check when member list survey type 360 change
  // states
  ddlQuestionUsers: DdlQuestionUsers[];
  ddlQuestionTypes: DdlQuestionTypes[];
  ddlQuestionGroups: DdlQuestionGroups[];
  ddlRegion: DdlRegion[];
  ddlDepartment: DdlQuestionDepartment[];
  ddlStaff: ISurveyStaff[];
  ddlEmbedApp: DdlIEmbedApp[];
  ddlQuestionPosition: DdlQuestionPosition[];
  ddlQuestionUnit: DdlQuestionUnit[];
  ddlQuestionLevel: DdlLevel[];
  ddlDivision: DdlGroupDivision[];
  ddlRestaurant: DdlGroupRestaurant[];
  ddlOutlook: DdlOutlook[];
  ddlRegionGroup: DdlRegion[];
  ddlDepartmentGroup: DdlQuestionDepartment[];
  ddlQuestionUnitGroup: DdlQuestionUnit[];
  ddlQuestionPositionGroup: DdlQuestionPosition[];
  ddlQuestionLevelGroup: DdlLevel[];
  ddlDivisionGroup: DdlGroupDivision[];
  ddlRestaurantGroup: DdlGroupRestaurant[];
  updateDDlStaff: (value: ISurveyStaff[]) => void;
  updateDdlOutlook: (value: DdlOutlook[]) => void;
  updateDDlDepartment: (value: DdlQuestionDepartment[]) => void;
  updateDdlQuestionUnit: (value: DdlQuestionUnit[]) => void;
  updateDdlGroupDivision: (value: DdlGroupDivision[]) => void;
  updateDdlGroupRestaurant: (value: DdlGroupRestaurant[]) => void;
  updateDDlDepartmentGroup: (value: DdlQuestionDepartment[]) => void;
  updateDdlQuestionUnitGroup: (value: DdlQuestionUnit[]) => void;
  updateDdlGroupDivisionGroup: (value: DdlGroupDivision[]) => void;
  updateDdlGroupRestaurantGroup: (value: DdlGroupRestaurant[]) => void;
  updateDdlGroupPositionGroup: (value: DdlQuestionPosition[]) => void;
  updateDdlGroupRegionGroup: (value: DdlRegion[]) => void;
  updateDdlGroupLevelGroup: (value: DdlLevel[]) => void;
  listOfUserReview: ISurveyUserReview[];
  surveyTotalStatistics: ISurveyTotalStatistics | null;
  numberPeopleDoNotSurvey: number;
  questionsReports: Array<ISingleQuestionReport>;
  hashCode: string;
  formatSurveyMemberListSelected: I360MemberList['contents'];

  //backup data member group data
  ddlRegionGroupBackup: DdlRegion[];
  ddlUnitGroupBackup: DdlQuestionUnit[];
  ddlDepartmentGroupBackup: DdlQuestionDepartment[];
  ddlDivisionGroupBackup: DdlGroupDivision[];
  ddlRestaurantGroupBackup: DdlGroupRestaurant[];
  ddlPositionGroupBackup: DdlQuestionPosition[];
  ddlLevelGroupBackup: DdlLevel[];

  // functions
  handleEditUserInfoDisplayedInfo: ({
    infoDisplayed,
    type,
  }: {
    infoDisplayed: { [x: string]: boolean };
    type: SurveyConst.CUSTOMER_INFO | SurveyConst.EMPLOYEE_INFO;
  }) => void;
  handleOpenModal: ({ type }: { type: ModalTypes }) => void;
  handleCloseModal: ({ type }: { type: ModalTypes }) => void;
  handleSwitchIsPersonDisplayed: (isDisplayed: boolean) => void;
  handleDisabledSurveyEdit: (isDisabled: boolean) => void;
  handleAddQuestion: (question: CombineTypeAnswer) => void;
  handleAddGroupQuestion: (sectionGroup: ISectionGroup) => void;
  handleMoveSectionInGroup: (moveObjId: string, moveDirection: 'move_up' | 'move_down') => void;
  handleMoveQuestionInGroup: (
    sourceID: string,
    questionID: CombineTypeAnswer['questionID'],
    moveDirection: 'move_up' | 'move_down'
  ) => void;
  handleRemoveQuestionInGroup: (
    sourceID: string,
    questionID: CombineTypeAnswer['questionID']
  ) => void;
  handleRemoveSectionInGroup: (sourceID: string) => void;
  handleSelectQuestionID: (questionID: string) => void;
  handleSelectSectionID: (sectionID: string) => void;
  handleEditSelectQuestionInGroupSection: (
    questionID: string,
    sectionID: string,
    newData: CombineTypeAnswer
  ) => void;
  handleSetSurveyInformation: (surveyInformation: IGetSurveyInfomation) => void;
  handleSetListOfBonusCodes: (listOfBonusCode: IUploadExcelCallApi) => void;
  handleMemberObjectGroup: (memberObjectGroup: number) => void;
  handleSetMemberSearch: (surveySearch: IGetSurveyMemberSearch) => void;
  handleSetMemberGroupFilter: (surveyMemberGroupFilter: IGetSurveyMemberGroupFilter) => void;
  handleSetMemberList: (memberList: any) => void;
  handleSetMemberList360: (memberList: any) => void;
  handleSetMemberListAll: (memberList: any) => void;
  handleSetMemberListAll360: (surveyMemberList360: any) => void;
  handleSetMemberListSelected: (surveyMemberListSelected: SurveyMemberListSelectedType[]) => void;
  handleSetMemberListChosen: (handleSetMemberListChosen: any[]) => void;
  handleSavingAllTabs: () => void;
  handleChangeTab: (typeOfTab: TSelectType) => void;
  handleSaveTab: (typeOfTab: TSelectType) => void;
  handleSavingAllTabsEnd: () => void;
  postSurveyInformation: (params: IGetSurveyInfomation) => void;
  handleInitSurvey: (type: SurveyConst.START_INIT | SurveyConst.END_INIT) => void;
  handleUpdateAllTabs: (params?: IGetSurveyInfomation) => Promise<void>;
  handleUpdateQuestion: () => void;
  handleUpdateQuestionEvaluated: (sectionID: string, dataQuestionEvaluated: any) => void;
  closeUploadModalThenUpdatingTab2: () => void;
  /**Demo */
  staffsDemo: ISurveyStaff[];
  handleLoadMoreStaffsDemo: () => () => void;
  handleSetIsViewSurvey: (isViewSurvey: boolean) => void;
  handleSetLockReadOnly: (isReadOnly: boolean) => void;
  handleSetSkipModalConfirm: (skipModalConfirm: boolean) => void;
  handleSetUserChangeModalAddQuestion: (isUserChangeModalAddQuestion: boolean) => void;
  handleSetInfoPeople: (infoPeople: string) => void;
  handleSetDisabledSurvey360: (disabledSurvey360: boolean) => void;
  handleSetSurveyTypeForm: (surveyType: number) => void;
  handleSetQuestionIDArrCopy: (questionIDArrCopy: string[]) => void;
  handleSetSurveyDataSave: (surveyDataSaveTab: ISurveyDataSave) => void;
  handleSetIsEvaluatedQuestionExist: (isEvaluatedQuestionExist: boolean) => void;
  setLoadingOn: () => void;
  setLoadingOff: () => void;
  handleSetIsCopySurvey: (isCopySurvey: boolean) => void;
  handleSetQuestionOrder: (questionOrder: string) => void;
  handleSetMemberGroupInfo: (memberGroupInfo: IMemberGroupInfo) => void;
  fetchDDLMemberGroup: () => void;
  handleSetLoadingMemberGroupInfo: (memberGroupInfo: ILoadingMemberGroupInfo) => void;
  handleSetActionChangeListMemberGroup: (
    typeActionChangeListMemberGroup: TActionChangeListMemberGroup
  ) => void;
  handleSetCurrentValueInformationTab: (surveyInformation: IGetSurveyInfomation) => void;
  //backup data member group data
  handleUpdateDDLRegionGroupBackup: (value: DdlRegion[]) => void;
  handleUpdateDDLUnitGroupBackup: (value: DdlQuestionUnit[]) => void;
  handleUpdateDDLDepartmentGroupBackup: (value: DdlQuestionDepartment[]) => void;
  handleUpdateDDLDivisionGroupBackup: (value: DdlGroupDivision[]) => void;
  handleUpdateDDLRestaurantGroupBackup: (value: DdlGroupRestaurant[]) => void;
  handleUpdateDDLPositionGroupBackup: (value: DdlQuestionPosition[]) => void;
  handleUpdateDDLLevelGroupBackup: (value: DdlLevel[]) => void;
  handleSetListStaff360: (value: IDDLCategory[]) => void;
  handleSetFetchQuestionAfterUploadExcel: (isFetchQuestionAfterUploadExcel: boolean) => void;

  handleSetParamFiltersEvaluatedQuestion: (
    paramFiltersEvaluatedQuestion: IParamFilterEvaluatedQuestionProps
  ) => void;
  handleSetIsFirstLoadTab: (isFirstLoadTab: { [x: string]: boolean }) => void;
  handleSetIsMemberList360Changed: (isMemberList360Changed: boolean) => void;
};

const initialState: InitialStateType = {
  // Common use
  isLoading: false,
  isSaveAllTabs: false,
  // statics
  isOpenModalPerson: false,
  isOpenModalQuestion: false,
  isOpenModalQuestionUserEvaluated: false,
  isOpenModalSection: false,
  isOpenModalConfirm: false,
  isOpenModalLockSurvey: false,
  isPersonInfoDisplayed: false,
  isOpenModalPublishSurvey: false,
  isOpenModalDraftSurvey: false,
  isOpenModalUploadSurvey: false,
  isOpenModalConfirmShowSurveyResults: false,
  isOpenModalDeleteQuestionUsedSurvey: false,
  isOpenModalConfirmExitEditSurvey: false,
  isOpenModalUploadEvaluatedPeople360: false,
  isDisabledSurveyEdit: false,
  isViewSurvey: false,
  isViewRoute: false,
  skipModalConfirm: false,
  isUserChangeModalAddQuestion: false,
  infoPeople: '',
  disabledSurvey360: false,
  isCopySurvey: false,
  surveyTypeForm: 1,
  isEvaluatedQuestionExist: false,
  isFetchQuestionAfterUploadExcel: false,
  employeeInfoDisplayed: {
    employeeId: true,
    name: true,
    department: true,
    restaurant: false,
    phoneNumber: false,
  },
  customerInfoDisplayed: {
    name: true,
    phoneNumber: true,
  },
  selectQuestionID: '',
  selectSectionID: '',
  surveyInformation: defaultSurveyInformation,
  currentValueInformationTab: defaultSurveyInformation,
  listOfBonusCode: defaultListOfBonusCode,
  surveyMemberList: [],
  surveyMemberListAll: [],
  surveyMemberList360: [],
  surveyMemberListAll360: [],
  questionIDArrCopy: [],
  surveyDataSaveTab: {
    surveyInformation: false,
    groupQuestions: false,
    surveyMemberList: false,
  },
  questionOrder: '1',
  memberObjectGroup: 1,
  surveyMemberSearch: {
    units: [],
    department: [],
    level: [],
    position: [],
    object360: [],
    staffs: [],
  },
  surveyMemberGroupFilter: surveyMemberGroupFilterDefault,
  surveyMemberListSelected: [],
  surveyMemberListChosen: [],
  groupQuestions: null,
  currentTab: 'information',
  previousTab: 'information',
  isInitSurvey: false,
  memberGroupInfo: defaultMemberGroupInfo,
  typeActionChangeListMemberGroup: 'loadNextPage',
  listStaff360: [],
  paramFiltersEvaluatedQuestion: defaultParamFiltersEvaluatedQuestion,
  isFirstLoadTab: {
    content: true,
    memberList: true,
  },
  isMemberList360Changed: true,
  // states
  ddlQuestionUsers: [],
  ddlQuestionTypes: [],
  ddlQuestionGroups: [],
  ddlRegion: [],
  ddlDepartment: [],
  ddlStaff: [],
  ddlEmbedApp: [],
  ddlQuestionPosition: [],
  ddlQuestionUnit: [],
  ddlQuestionLevel: [],
  ddlDivision: [],
  ddlRestaurant: [],
  ddlOutlook: [],
  ddlRegionGroup: [],
  ddlQuestionUnitGroup: [],
  ddlQuestionPositionGroup: [],
  ddlQuestionLevelGroup: [],
  ddlDivisionGroup: [],
  ddlRestaurantGroup: [],
  ddlDepartmentGroup: [],
  //backup data member group data
  ddlRegionGroupBackup: [],
  ddlUnitGroupBackup: [],
  ddlDepartmentGroupBackup: [],
  ddlDivisionGroupBackup: [],
  ddlRestaurantGroupBackup: [],
  ddlPositionGroupBackup: [],
  ddlLevelGroupBackup: [],
  updateDDlStaff: (value: ISurveyStaff[]) => null,
  updateDDlDepartment: (value: DdlQuestionDepartment[]) => null,
  updateDdlQuestionUnit: (value: DdlQuestionUnit[]) => null,
  updateDdlGroupDivision: (value: DdlGroupDivision[]) => null,
  updateDdlGroupRestaurant: (value: DdlGroupRestaurant[]) => null,
  updateDdlOutlook: (value: DdlOutlook[]) => null,
  updateDdlQuestionUnitGroup: (value: DdlQuestionUnit[]) => null,
  updateDDlDepartmentGroup: (value: DdlQuestionDepartment[]) => null,
  updateDdlGroupDivisionGroup: (value: DdlGroupDivision[]) => null,
  updateDdlGroupRestaurantGroup: (value: DdlGroupRestaurant[]) => null,
  updateDdlGroupPositionGroup: (value: DdlQuestionPosition[]) => null,
  updateDdlGroupRegionGroup: (value: DdlRegion[]) => null,
  updateDdlGroupLevelGroup: (value: DdlLevel[]) => null,
  listOfUserReview: [],
  surveyTotalStatistics: null,
  numberPeopleDoNotSurvey: 0,
  questionsReports: [],
  hashCode: '',
  formatSurveyMemberListSelected: [],
  loadingMemberGroupInfo: defaultLoadingMemberGroupInfo,

  handleEditUserInfoDisplayedInfo: ({
    infoDisplayed,
    type,
  }: {
    infoDisplayed: { [x: string]: boolean };
    type: SurveyConst.CUSTOMER_INFO | SurveyConst.EMPLOYEE_INFO;
  }) => null,
  handleOpenModal: ({ type }: { type: ModalTypes }) => null,
  handleCloseModal: ({ type }: { type: ModalTypes }) => null,
  handleSwitchIsPersonDisplayed: (isDisplayed: boolean) => null,
  handleDisabledSurveyEdit: (isDisabled: boolean) => null,
  handleAddQuestion: (question: CombineTypeAnswer) => null,
  handleAddGroupQuestion: (sectionGroup: ISectionGroup) => null,
  handleMoveSectionInGroup: (moveObjId: string, moveDirection: 'move_up' | 'move_down') => null,
  handleMoveQuestionInGroup: (
    sourceID: string,
    questionID: CombineTypeAnswer['questionID'],
    moveDirection: 'move_up' | 'move_down'
  ) => null,
  handleRemoveQuestionInGroup: (sourceID: string, questionID: CombineTypeAnswer['questionID']) =>
    null,
  handleRemoveSectionInGroup: (sourceID: string) => null,
  /** */
  handleSelectQuestionID: (questionID: string) => null,
  handleSelectSectionID: (sectionID: string) => null,
  handleEditSelectQuestionInGroupSection: (
    questionID: string,
    sectionID: string,
    newData: CombineTypeAnswer
  ) => null,
  handleSetSurveyInformation: (surveyInformation: IGetSurveyInfomation) => null,
  handleSetListOfBonusCodes: (listOfBonusCode: IUploadExcelCallApi) => null,
  handleMemberObjectGroup: (handleMemberObjectGroup: number) => null,
  handleSetMemberSearch: (surveyMemberSearch: IGetSurveyMemberSearch) => null,
  handleSetMemberGroupFilter: (surveyMemberGroupFilter: IGetSurveyMemberGroupFilter) => null,
  handleSetMemberList: (memberList: any) => null,
  handleSetMemberList360: (memberList360: any) => null,
  handleSetMemberListAll: (memberList: any) => null,
  handleSetMemberListAll360: (memberListAll360: any) => null,
  handleSetMemberListSelected: (surveyMemberListSelected: SurveyMemberListSelectedType[]) => null,
  handleSetMemberListChosen: (handleSetMemberListChosen: any[]) => null,
  handleSavingAllTabs: () => Promise.resolve(),
  handleChangeTab: (typeOfTab: TSelectType) => null,
  handleSaveTab: (typeOfTab: TSelectType) => null,
  handleSavingAllTabsEnd: () => null,
  postSurveyInformation: (params: IGetSurveyInfomation) => null,
  handleInitSurvey: (type: SurveyConst.START_INIT | SurveyConst.END_INIT) => null,
  handleUpdateAllTabs: (params?: IGetSurveyInfomation) => Promise.resolve(),
  handleUpdateQuestion: () => null,
  handleUpdateQuestionEvaluated: (sourceID: string, dataQuestionEvaluated: any) => null,
  closeUploadModalThenUpdatingTab2: () => null,
  /**Demo */
  staffsDemo: [],
  handleLoadMoreStaffsDemo: () => () => null,
  handleSetIsViewSurvey: (isViewSurvey: boolean) => null,
  handleSetLockReadOnly: (isReadOnly: boolean) => null,
  handleSetSkipModalConfirm: (skipModalConfirm: boolean) => null,
  handleSetUserChangeModalAddQuestion: (isUserChangeModalAddQuestion: boolean) => null,
  handleSetInfoPeople: (infoPeople: string) => null,
  handleSetDisabledSurvey360: (disabledSurvey360: boolean) => null,
  handleSetSurveyTypeForm: (surveyType: number) => null,
  handleSetQuestionIDArrCopy: (questionIDArrCopy: string[]) => null,
  handleSetSurveyDataSave: (surveyDataSaveTab: ISurveyDataSave) => null,
  handleSetIsEvaluatedQuestionExist: (isEvaluatedQuestionExist: boolean) => null,
  setLoadingOn: () => null,
  setLoadingOff: () => null,
  handleSetIsCopySurvey: (isCopySurvey: boolean) => null,
  handleSetQuestionOrder: (questionOrder: string) => null,
  handleSetMemberGroupInfo: (memberGroupInfo: IMemberGroupInfo) => null,
  fetchDDLMemberGroup: () => null,
  handleSetLoadingMemberGroupInfo: (memberGroupInfo: ILoadingMemberGroupInfo) => null,
  handleSetActionChangeListMemberGroup: (
    typeActionChangeListMemberGroup: TActionChangeListMemberGroup
  ) => null,
  handleSetCurrentValueInformationTab: (surveyInformation: IGetSurveyInfomation) => null,
  //backup data member group data
  handleUpdateDDLRegionGroupBackup: (value: DdlRegion[]) => null,
  handleUpdateDDLUnitGroupBackup: (value: DdlQuestionUnit[]) => null,
  handleUpdateDDLDepartmentGroupBackup: (value: DdlQuestionDepartment[]) => null,
  handleUpdateDDLDivisionGroupBackup: (value: DdlGroupDivision[]) => null,
  handleUpdateDDLRestaurantGroupBackup: (value: DdlGroupRestaurant[]) => null,
  handleUpdateDDLPositionGroupBackup: (value: DdlQuestionPosition[]) => null,
  handleUpdateDDLLevelGroupBackup: (value: DdlLevel[]) => null,
  handleSetListStaff360: (value: IDDLCategory[]) => null,
  handleSetFetchQuestionAfterUploadExcel: (isFetchQuestionAfterUploadExcel: boolean) => null,
  handleSetParamFiltersEvaluatedQuestion: (
    paramFiltersEvaluatedQuestion: IParamFilterEvaluatedQuestionProps
  ) => null,
  handleSetIsFirstLoadTab: (isFirstLoadTab: { [x: string]: boolean }) => null,
  handleSetIsMemberList360Changed: (isMemberList360Changed: boolean) => null,
};

const SurveyContext = createContext<InitialStateType>(initialState);

const SurveyProvider = ({ children }: ISurveyProvider) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { errorNotification, successNotification } = useToastNotification();
  const { messageError } = useHandleError();
  const { handleDuplicateStaffError, duplicateStaffConflictModal } =
    useDuplicateStaffConflictModal();

  const [state, dispatch] = useReducer(reducer, initialState);
  // Chỉ xem do không giữ khóa chỉnh sửa (GSURVEY-732) — gộp vào isViewSurvey cho mọi tab
  const [isLockReadOnly, setIsLockReadOnly] = useState(false);

  const { departments } = state.surveyInformation;
  const initQuestionEvaluatedWhenUpdate = defaultQuestionEvaluatedWhenUpdateQuestion(departments);

  const evaluatedQuestionID = useMemo(() => {
    return `00000000_${state.surveyInformation.surveyID}`;
  }, [state.surveyInformation.surveyID]);

  const formatSurveyMemberListSelected = useMemo(() => {
    const results = state.surveyMemberListSelected.reduce<I360MemberList['contents']>(
      (acc, curr) => {
        const value = Object.values(curr)[1] as I360MemberList['contents'];
        return acc.concat(...value);
      },
      []
    );
    return results;
  }, [JSON.stringify(state.surveyMemberListSelected)]);

  //
  const [ddlQuestionUsers, setDdlQuestionUsers] = useState<DdlQuestionUsers[]>([]);
  const [ddlQuestionTypes, setDdlQuestionTypes] = useState<DdlQuestionTypes[]>([]);
  const [ddlQuestionGroups, setDdlQuestionGroups] = useState<DdlQuestionGroups[]>([]);
  const [ddlDepartment, setDdlDepartment] = useState<DdlQuestionDepartment[]>([]);
  const [ddlQuestionPosition, setDdlQuestionPosition] = useState<DdlQuestionPosition[]>([]);
  const [ddlEmbedApp, setDdlEmbedApp] = useState<DdlIEmbedApp[]>([]);
  const [ddlQuestionUnit, setDdlQuestionUnit] = useState<DdlQuestionUnit[]>([]);
  const [ddlQuestionLevel, setDdlQuestionLevel] = useState<DdlLevel[]>([]);
  const [ddlRegion, setDdlQuestionRegions] = useState<DdlRegion[]>([]);
  const [ddlDivision, setDdlDivision] = useState<DdlGroupDivision[]>([]);
  const [ddlRestaurant, setDdlRestaurant] = useState<DdlGroupRestaurant[]>([]);

  const [ddlRegionGroup, setDdlQuestionRegionsGroup] = useState<DdlRegion[]>([]);
  const [ddlQuestionUnitGroup, setDdlQuestionUnitGroup] = useState<DdlQuestionUnit[]>([]);
  const [ddlDepartmentGroup, setDdlDepartmentGroup] = useState<DdlQuestionDepartment[]>([]);
  const [ddlDivisionGroup, setDdlDivisionGroup] = useState<DdlGroupDivision[]>([]);
  const [ddlQuestionLevelGroup, setDdlQuestionLevelGroup] = useState<DdlLevel[]>([]);
  const [ddlRestaurantGroup, setDdlRestaurantGroup] = useState<DdlGroupRestaurant[]>([]);
  const [ddlQuestionPositionGroup, setDdlQuestionPositionGroup] = useState<DdlQuestionPosition[]>(
    []
  );

  const [ddlOutlook, setDdlOutlook] = useState<DdlOutlook[]>([]);
  const [ddlStaff, setDdlStaff] = useState<ISurveyStaff[]>([]);

  const [surveyTotalStatistics, setSurveyTotalStatistics] = useState<ISurveyTotalStatistics | null>(
    null
  );
  const [numberPeopleDoNotSurvey, setNumberPeopleDoNotSurvey] = useState(0);
  const [questionsReports, setQuestionsReports] = useState<Array<ISingleQuestionReport>>([]);
  const [listOfUserReview, setListOfUserReivew] = useState<ISurveyUserReview[]>([]);
  const [hashCode, setHashCode] = useState('');
  //

  const [isInfomationTabUpdate, setInfomationTabUpdate] = useState(false);
  const [isContentTabUpdate, setContentTabUpdate] = useState(false);
  const [isListOfUserTabUpdate, setListOfUserTabUpdate] = useState(false);
  const isResetStaff = useRef<number>(actionUpdateStaffsConstant.KEEP_STATE);
  const [staffsDemo, setStaffsDemo] = useState<ISurveyStaff[]>([]);
  const currentSurveyType = useRef<number>(1);
  const currentSurveyForm = useRef<number>(1);

  const handleLoadMoreStaffsDemo = () => {
    let fetchCount = 2;

    return () => {
      setStaffsDemo((prev) => {
        return [...prev, ...ddlStaff.slice(10, 10 * fetchCount)];
      });
      fetchCount += 1;
    };
  };

  // const providedStaff = useMemo(() => {
  //   const params = {
  //     units: [],
  //     departments: [],
  //     positions: [],
  //     levels: [],
  //     survey360Objects: [],
  //   };
  //   const staffList = postDDLResultStaffApi(params);
  //   return {
  //     value: ddlStaff,
  //     setValue: (value: ISurveyStaff[]) => setDdlStaff(value),
  //   };
  // }, [ddlQuestionUnit]);
  /** */
  const setLoadingOn = () => {
    dispatch({
      type: ActionTypes.SET_LOADING,
      payload: {
        type: SurveyConst.LOADING_ON,
      },
    });
  };
  const setLoadingOff = () => {
    dispatch({
      type: ActionTypes.SET_LOADING,
      payload: {
        type: SurveyConst.LOADING_OFF,
      },
    });
  };
  /** */
  const handleChangeTab = (typeOfTab: TSelectType) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE_TABS,
      payload: {
        typeOfTab,
      },
    });
  };
  const handleSaveTab = (previousTab: TSelectType) => {
    dispatch({
      type: ActionTypes.SET_SAVE_TAB,
      payload: {
        previousTab,
      },
    });
  };

  const handleDisabledSurveyEdit = (isDisabled: boolean) => {
    dispatch({
      type: ActionTypes.SET_DISABLED_SURVEY_EDIT,
      payload: {
        isDisabledSurveyEdit: isDisabled,
      },
    });
  };
  const handleSetUserChangeModalAddQuestion = (isUserChangeModalAddQuestion: boolean) => {
    dispatch({
      type: ActionTypes.SET_USER_CHANGE_MODAL_ADD_QUESTION,
      payload: {
        isUserChangeModalAddQuestion: isUserChangeModalAddQuestion,
      },
    });
  };

  /**
   * Survey Tab 2 Functions
   */
  const handleEditUserInfoDisplayedInfo = ({
    infoDisplayed,
    type,
  }: {
    infoDisplayed: { [x: string]: boolean };
    type: SurveyConst.CUSTOMER_INFO | SurveyConst.EMPLOYEE_INFO;
  }) => {
    dispatch({
      type: ActionTypes.EDIT_EMPLOYEE_INFO,
      payload: {
        infoDisplayed,
        type,
      },
    });
  };

  const handleOpenModal = ({ type }: { type: ModalTypes }) => {
    if (type === 'person-info') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_USER_INFO,
      });
    }
    if (type === 'adding-questions') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_ADDING_QUESTION,
      });
    }
    if (type === 'adding-questions-user-evaluated') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_ADDING_QUESTION_USER_EVALUATED,
      });
    }
    if (type === 'adding-secion') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_ADDING_SECTION,
      });
    }
    if (type === 'confirm') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_CONFIRM,
      });
    }
    if (type === 'lock-survey') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_LOCK_SURVEY,
      });
    }
    if (type === 'publish-survey') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_PUBLISH_SURVEY,
      });
    }
    if (type === 'draft-survey') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_DRAFT_SURVEY,
      });
    }
    if (type === 'upload-survey-question') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_UPLOAD_SURVEY,
      });
    }
    if (type === 'confirm-show-survey-results') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_CONFIRM_SHOW_SURVEY_RESULTS,
      });
    }
    if (type === 'delete-question-used-in-survey') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY,
      });
    }
    if (type === 'warning-exit-edit-survey') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_CONFIRM_EXIT_EDIT_SURVEY,
      });
    }
    if (type === 'upload-evaluate-people-360') {
      dispatch({
        type: ActionTypes.OPEN_MODAL_UPLOAD_EVALUATED_PEOPLE_360,
      });
    }
  };

  const handleCloseModal = ({ type }: { type: ModalTypes }) => {
    if (type === 'person-info') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_USER_INFO,
      });
    }
    if (type === 'adding-questions') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_ADDING_QUESTION,
      });
    }
    if (type === 'adding-questions-user-evaluated') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_ADDING_QUESTION_USER_EVALUATED,
      });
    }
    if (type === 'adding-secion') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_ADDING_SECTION,
      });
    }
    if (type === 'confirm') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_CONFIRM,
      });
    }
    if (type === 'lock-survey') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_LOCK_SURVEY,
      });
    }
    if (type === 'publish-survey') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_PUBLISH_SURVEY,
      });
    }
    if (type === 'draft-survey') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_DRAFT_SURVEY,
      });
    }
    if (type === 'upload-survey-question') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_UPLOAD_SURVEY,
      });
    }
    if (type === 'confirm-show-survey-results') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_CONFIRM_SHOW_SURVEY_RESULTS,
      });
    }
    if (type === 'delete-question-used-in-survey') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_CONFIRM_DELETE_QUESTION_USED_IN_SURVEY,
      });
    }
    if (type === 'warning-exit-edit-survey') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_CONFIRM_EXIT_EDIT_SURVEY,
      });
    }
    if (type === 'upload-evaluate-people-360') {
      dispatch({
        type: ActionTypes.CLOSE_MODAL_UPLOAD_EVALUATED_PEOPLE_360,
      });
    }
  };

  const handleSwitchIsPersonDisplayed = (isDisplayed: boolean) => {
    dispatch({
      type: ActionTypes.SWITCH_INFO_PERSON_DISPLAYED,
      payload: {
        isPersonInfoDisplayed: isDisplayed,
      },
    });
  };

  const handleAddQuestion = (question: CombineTypeAnswer) => {
    dispatch({
      type: ActionTypes.ADD_QUESTION_INTO_QUESTIONLIST,
      payload: {
        question,
      },
    });
  };
  const handleAddQuestionInFirstList = (question: CombineTypeAnswer) => {
    dispatch({
      type: ActionTypes.ADD_QUESTION_INTO_FIRST_QUESTIONLIST,
      payload: {
        question,
      },
    });
  };

  const handleAddGroupQuestion = (sectionGroup: ISectionGroup) => {
    dispatch({
      type: ActionTypes.ADD_GROUP_QUESTIONS,
      payload: {
        sectionGroup,
      },
    });
  };

  const handleMoveSectionInGroup = (moveObjId: string, moveDirection: 'move_up' | 'move_down') => {
    dispatch({
      type: ActionTypes.MOVE_SECTION_IN_GROUP,
      payload: {
        moveObjId,
        moveDirection,
      },
    });
  };

  const handleMoveQuestionInGroup = (
    sourceID: string,
    questionID: CombineTypeAnswer['questionID'],
    moveDirection: 'move_up' | 'move_down'
  ) => {
    dispatch({
      type: ActionTypes.MOVE_QUESTION_IN_GROUP,
      payload: {
        moveDirection,
        sourceID,
        questionID,
      },
    });
  };

  const handleRemoveQuestionInGroup = (
    sourceID: string,
    questionID: CombineTypeAnswer['questionID']
  ) => {
    dispatch({
      type: ActionTypes.REMOVE_QUESTION_IN_GROUP,
      payload: {
        sourceID,
        questionID,
      },
    });
  };
  const handleUpdateQuestionEvaluated = (sourceID: string, dataQuestionEvaluated: any) => {
    dispatch({
      type: ActionTypes.UPDATE_QUESTION_EVALUATED_IN_GROUP,
      payload: {
        sourceID,
        dataQuestionEvaluated,
      },
    });
  };

  const handleRemoveSectionInGroup = (sourceID: string) => {
    dispatch({
      type: ActionTypes.REMOVE_SECTION_IN_GROUP,
      payload: {
        sourceID,
      },
    });
  };

  const handleSelectQuestionID = (questionID: string) => {
    dispatch({
      type: ActionTypes.SET_SELECT_QUESTION,
      payload: {
        questionID,
      },
    });
  };

  const handleSelectSectionID = (sectionID: string) => {
    dispatch({
      type: ActionTypes.SET_SELECT_SECTION,
      payload: {
        sectionID,
      },
    });
  };

  const handleEditSelectQuestionInGroupSection = (
    questionID: string,
    sectionID: string,
    newData: CombineTypeAnswer
  ) => {
    dispatch({
      type: ActionTypes.EDIT_SELECT_QUESTION_IN_GROUP,
      payload: {
        questionID,
        sectionID,
        newData,
      },
    });
  };

  const handleSetSurveyInformation = (surveyInformation: IGetSurveyInfomation) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_1_INFORMATION,
      payload: {
        surveyInformation,
      },
    });
  };

  const handleSetListOfBonusCodes = (listOfBonusCode: IUploadExcelCallApi) => {
    dispatch({
      type: ActionTypes.SET_LIST_OF_BONUS_CODE_TAB_1_INFORMATION,
      payload: {
        listOfBonusCode,
      },
    });
  };

  const handleSetMemberSearch = (surveyMemberSearch: IGetSurveyMemberSearch) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERSEARCH,
      payload: {
        surveyMemberSearch,
      },
    });
  };
  const handleSetMemberGroupFilter = (surveyMemberGroupFilter: IGetSurveyMemberGroupFilter) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBER_GROUP_FILTER,
      payload: {
        surveyMemberGroupFilter,
      },
    });
  };

  const handleMemberObjectGroup = (memberObjectGroup: number) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBER_OBJECTGROUP,
      payload: {
        memberObjectGroup,
      },
    });
  };

  const handleSetMemberList = (surveyMemberList: any) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST,
      payload: {
        surveyMemberList,
      },
    });
  };

  const handleSetMemberListAll = (surveyMemberListAll: any) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_ALL,
      payload: {
        surveyMemberListAll,
      },
    });
  };

  const handleSetMemberList360 = (surveyMemberList360: any) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_360,
      payload: {
        surveyMemberList360,
      },
    });
  };

  const handleSetMemberListAll360 = (surveyMemberListAll360: any) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_ALL_360,
      payload: {
        surveyMemberListAll360,
      },
    });
  };

  const handleSetMemberListSelected = (
    surveyMemberListSelected: SurveyMemberListSelectedType[]
  ) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_SELECTED,
      payload: {
        surveyMemberListSelected,
      },
    });
  };

  const handleSetMemberListChosen = (surveyMemberListChosen: any[]) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TAB_3_MEMBERLIST_CHOSEN,
      payload: {
        surveyMemberListChosen,
      },
    });
  };

  const handleSetInfoPeople = (infoPeople: string) => {
    dispatch({
      type: ActionTypes.SET_INFO_PEOPLE,
      payload: {
        infoPeople,
      },
    });
  };

  const handleSetDisabledSurvey360 = (disabledSurvey360: boolean) => {
    dispatch({
      type: ActionTypes.SET_DISABLED_SURVEY_360,
      payload: {
        disabledSurvey360,
      },
    });
  };

  const handleSetIsEvaluatedQuestionExist = (isEvaluatedQuestionExist: boolean) => {
    dispatch({
      type: ActionTypes.SET_EVALUATED_QUESTION_EXIST,
      payload: {
        isEvaluatedQuestionExist,
      },
    });
  };

  const handleSetIsMemberList360Changed = (isMemberList360Changed: boolean) => {
    dispatch({
      type: ActionTypes.SET_IS_MEMBER_LIST_360_CHANGED,
      payload: {
        isMemberList360Changed,
      },
    });
  };

  const handleDdlStaff = (valueNew: ISurveyStaff[]) => {
    setDdlStaff(valueNew);
  };

  const handleDdlDepartment = (valueNew: DdlQuestionDepartment[]) => {
    setDdlDepartment(valueNew);
  };
  const handleDdlQuestionUnit = (valueNew: DdlQuestionUnit[]) => {
    setDdlQuestionUnit(valueNew);
  };
  const handleDdlGroupDivision = (valueNew: DdlGroupDivision[]) => {
    setDdlDivision(valueNew);
  };
  const handleDdlGroupRestaurant = (valueNew: DdlGroupRestaurant[]) => {
    setDdlRestaurant(valueNew);
  };
  const handleDdlOutlook = (valueNew: DdlOutlook[]) => {
    setDdlOutlook(valueNew);
  };

  const handleDdlDepartmentGroup = (valueNew: DdlQuestionDepartment[]) => {
    setDdlDepartmentGroup(valueNew);
  };
  const handleDdlQuestionUnitGroup = (valueNew: DdlQuestionUnit[]) => {
    setDdlQuestionUnitGroup(valueNew);
  };
  const handleDdlGroupDivisionGroup = (valueNew: DdlGroupDivision[]) => {
    setDdlDivisionGroup(valueNew);
  };
  const handleDdlGroupRestaurantGroup = (valueNew: DdlGroupRestaurant[]) => {
    setDdlRestaurantGroup(valueNew);
  };

  const handleUpdateDdlPositionGroup = (valueNew: DdlQuestionPosition[]) => {
    setDdlQuestionPositionGroup(valueNew);
  };
  const handleUpdateDdlRegionGroup = (valueNew: DdlRegion[]) => {
    setDdlQuestionRegionsGroup(valueNew);
  };
  const handleUpdateDdlLevelGroup = (valueNew: DdlLevel[]) => {
    setDdlQuestionLevelGroup(valueNew);
  };

  const handleInitSurvey = (type: SurveyConst.START_INIT | SurveyConst.END_INIT) => {
    dispatch({
      type: ActionTypes.INIT_SURVEY,
      payload: {
        type,
      },
    });
  };

  const handleSavingAllTabs = () => {
    dispatch({
      type: ActionTypes.SAVE_ALL_TABS_BEGIN,
    });
  };

  const handleSavingAllTabsEnd = () => {
    dispatch({
      type: ActionTypes.SAVE_ALL_TABS_END,
    });
  };
  const handleSetIsViewSurvey = (isViewSurvey: boolean) => {
    dispatch({
      type: ActionTypes.SET_IS_VIEW_SURVEY,
      payload: {
        isViewSurvey,
      },
    });
  };

  const handleSetSkipModalConfirm = (skipModalConfirm: boolean) => {
    dispatch({
      type: ActionTypes.SET_SKIP_MODAL_CONFIRM,
      payload: {
        skipModalConfirm: skipModalConfirm,
      },
    });
  };

  const handleSetSurveyTypeForm = (surveyTypeForm: number) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_TYPE_FORM,
      payload: {
        surveyTypeForm: surveyTypeForm,
      },
    });
  };

  const handleSetQuestionIDArrCopy = (questionIDArrCopy: string[]) => {
    dispatch({
      type: ActionTypes.SET_QUESTION_ID_ARR_COPY,
      payload: {
        questionIDArrCopy: questionIDArrCopy,
      },
    });
  };

  const handleSetSurveyDataSave = (surveyDataSaveTab: ISurveyDataSave) => {
    dispatch({
      type: ActionTypes.SET_SURVEY_DATA_SAVE,
      payload: {
        surveyDataSaveTab: surveyDataSaveTab,
      },
    });
  };

  const handleSetIsCopySurvey = (isCopySurvey: boolean) => {
    dispatch({
      type: ActionTypes.SET_IS_COPY_SURVEY,
      payload: {
        isCopySurvey: isCopySurvey,
      },
    });
  };
  const handleSetQuestionOrder = (questionOrder: string) => {
    dispatch({
      type: ActionTypes.SET_QUESTION_ORDER,
      payload: {
        questionOrder: questionOrder,
      },
    });
  };

  const handleSetMemberGroupInfo = (memberGroupInfo: IMemberGroupInfo) => {
    dispatch({
      type: ActionTypes.SET_MEMBER_GROUP_INFO,
      payload: {
        memberGroupInfo: memberGroupInfo,
      },
    });
  };

  const handleSetLoadingMemberGroupInfo = (loadingMemberGroupInfo: ILoadingMemberGroupInfo) => {
    dispatch({
      type: ActionTypes.SET_LOADING_MEMBER_GROUP_INFO,
      payload: {
        loadingMemberGroupInfo: loadingMemberGroupInfo,
      },
    });
  };

  const handleSetActionChangeListMemberGroup = (
    typeActionChangeListMemberGroup: TActionChangeListMemberGroup
  ) => {
    dispatch({
      type: ActionTypes.SET_TYPE_ACTION_CHANGE_LIST_MEMBER_GROUP,
      payload: {
        typeActionChangeListMemberGroup: typeActionChangeListMemberGroup,
      },
    });
  };

  const handleSetCurrentValueInformationTab = (surveyInformation: IGetSurveyInfomation) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_VALUE_INFORMATION_TAB,
      payload: {
        surveyInformation: surveyInformation,
      },
    });
  };

  const handleUpdateDDLRegionGroupBackup = (value: DdlRegion[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_REGION_MEMBER_GROUP_BACKUP,
      payload: {
        ddlRegionGroupBackup: value,
      },
    });
  };

  const handleUpdateDDLUnitGroupBackup = (value: DdlQuestionUnit[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_UNIT_MEMBER_GROUP_BACKUP,
      payload: {
        ddlUnitGroupBackup: value,
      },
    });
  };

  const handleUpdateDDLDepartmentGroupBackup = (value: DdlQuestionDepartment[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_DEPARTMENT_MEMBER_GROUP_BACKUP,
      payload: {
        ddlDepartmentGroupBackup: value,
      },
    });
  };

  const handleUpdateDDLDivisionGroupBackup = (value: DdlGroupDivision[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_DIVISION_MEMBER_GROUP_BACKUP,
      payload: {
        ddlDivisionGroupBackup: value,
      },
    });
  };

  const handleUpdateDDLRestaurantGroupBackup = (value: DdlGroupRestaurant[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_RESTAURANT_MEMBER_GROUP_BACKUP,
      payload: {
        ddlRestaurantGroupBackup: value,
      },
    });
  };

  const handleUpdateDDLPositionGroupBackup = (value: DdlQuestionPosition[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_POSITION_MEMBER_GROUP_BACKUP,
      payload: {
        ddlPositionGroupBackup: value,
      },
    });
  };

  const handleUpdateDDLLevelGroupBackup = (value: DdlLevel[]) => {
    dispatch({
      type: ActionTypes.SET_DDL_LEVEL_MEMBER_GROUP_BACKUP,
      payload: {
        ddlLevelGroupBackup: value,
      },
    });
  };

  const handleSetListStaff360 = (value: IDDLCategory[]) => {
    dispatch({
      type: ActionTypes.SET_LIST_STAFF_360,
      payload: {
        listStaff360: value,
      },
    });
  };

  const handleSetFetchQuestionAfterUploadExcel = (isFetchQuestionAfterUploadExcel: boolean) => {
    dispatch({
      type: ActionTypes.SET_FETCH_QUESTION_AFTER_UPLOAD_EXCEL,
      payload: {
        isFetchQuestionAfterUploadExcel: isFetchQuestionAfterUploadExcel,
      },
    });
  };

  const handleSetParamFiltersEvaluatedQuestion = (
    paramFiltersEvaluatedQuestion: IParamFilterEvaluatedQuestionProps
  ) => {
    dispatch({
      type: ActionTypes.SET_PARAM_FILTERS_EVALUATED_QUESTION,
      payload: {
        paramFiltersEvaluatedQuestion: paramFiltersEvaluatedQuestion,
      },
    });
  };

  const handleSetIsFirstLoadTab = (isFirstLoadTab: { [x: string]: boolean }) => {
    dispatch({
      type: ActionTypes.SET_IS_FIRST_LOAD_TAB,
      payload: {
        isFirstLoadTab: isFirstLoadTab,
      },
    });
  };

  /**Helper Functions*/
  const transformGroupQuestionsToParentQuestions = useCallback(() => {
    if (!state.groupQuestions) return null;
    const evaluatedQuestion = findQuestionArrByField(
      state.groupQuestions,
      mappingSelectType.evaluated,
      'questionTypeID'
    );

    const parentKeys = Object.keys(state?.groupQuestions);
    const rootGroupQuestions = state.groupQuestions;
    const rootGroupQuestionsFormat = Object.keys(state.groupQuestions).reduce(
      (groupIndex, curIndex) => {
        const questionArr = rootGroupQuestions[curIndex].question.reduce<CombineTypeAnswer[]>(
          (quesArr, curVal) => {
            let questionFormat = null;

            if (
              state.surveyTypeForm === 1 &&
              evaluatedQuestion &&
              evaluatedQuestion.length > 0 &&
              curVal.questionTypeID === mappingSelectType.evaluated
            ) {
              questionFormat = null;
            } else {
              if (curVal.questionID) {
                questionFormat = curVal;
              }
            }
            if (questionFormat) {
              quesArr.push(questionFormat);
            }
            return quesArr;
          },
          []
        );
        Object.assign(groupIndex, {
          [curIndex]: {
            ...rootGroupQuestions[curIndex],
            question: questionArr,
          },
        });
        return groupIndex;
      },
      {}
    );

    const objPeopleSurvey =
      state.surveyInformation.surveyObject === 1
        ? state.employeeInfoDisplayed
        : state.customerInfoDisplayed;

    const surveyPeopleInfo = Object.keys(objPeopleSurvey).reduce<string[]>((acc, val) => {
      if (objPeopleSurvey[val] && state.isPersonInfoDisplayed) {
        acc.push(objectSurveyPeopleByNumber[val]);
        return acc;
      }
      return acc;
    }, []);

    const parentQuestions = parentKeys.map<IParentQuestions>((key, parentIndex) => ({
      parentQuestionID: key,
      parentQuestionContent: (rootGroupQuestionsFormat as ISectionGroup)[key].sectionName ?? '',
      numericalOrder: parentIndex,
      questions: (rootGroupQuestionsFormat as ISectionGroup)[key].question.map((q, qIndex) => {
        return {
          questionID: q.questionID,
          numericalOrder: qIndex,
        };
      }),
    }));

    const formattedParameter: ISurveyAddQuestion = {
      surveyID: state.surveyInformation.surveyID,
      parentQuestions,
      surveyPeopleInfo,
    };
    return formattedParameter;
  }, [
    JSON.stringify(state.groupQuestions),
    state.employeeInfoDisplayed,
    state.customerInfoDisplayed,
    state.isPersonInfoDisplayed,
    state.surveyInformation.surveyType,
    state.surveyTypeForm,
  ]);

  const transformSurveyQuestionIntoGroupedQuestion = (surveyQuestions: ISurveyQuestions[]) => {
    const formattedSectionGroup =
      surveyQuestions.reduce(
        (acc, val) => {
          return {
            ...acc,
            [val.parentQuestionID.toString()]: {
              sectionName: val.parentQuestionContent,
              question: val.questions,
            },
          };
        },
        {
          [SurveyConst.INIT_GROUP_QUESTION]: {
            sectionName: '',
            question: [],
          },
        } as ISectionGroup
      ) ?? {};
    return formattedSectionGroup;
  };

  const transformGetSurveyInfoToSetSurveyInfo = (
    surveyInfo: IGetSurveyInfomation
  ): ISetSurveyInfomation => {
    const newUserID = handleGetUSerID();
    const updatedInfomation: ISetSurveyInfomation = {
      ...surveyInfo,
      departments: surveyInfo.departments.map((d) => ({
        departmentID: (d.key ? d.key : d.departmentID) as string,
      })),
      apps: surveyInfo.apps.map((d) => ({
        appID: (d.key ? d.key : d.appID) as string,
      })),
      survey360Objects: surveyInfo.survey360Objects.map((s) => ({
        objectID: Number(s.objectID) as IGetSurveyInfomation['survey360Objects'][0]['objectID'],
      })),
      surveyViewers: surveyInfo.surveyViewers.reduce<Pick<ISurveyViewers, 'viewerID'>[]>(
        (acc, cur) => {
          if (cur.viewerID !== 'all') {
            acc.push({
              viewerID: cur.viewerID,
            });
          }
          return acc;
        },
        []
      ),
      userCanViewSurvey: Array.isArray(surveyInfo.userCanViewSurvey)
        ? surveyInfo.userCanViewSurvey
        : [],
      userCanUpdateSurvey: Array.isArray(surveyInfo.userCanUpdateSurvey)
        ? surveyInfo.userCanUpdateSurvey
        : [],
      startDate: dayjs(surveyInfo.startDate).format('DD/MM/YYYY'),
      endDate: dayjs(surveyInfo.endDate).format('DD/MM/YYYY'),
      surveyType: Number(surveyInfo.surveyType) as IGetSurveyInfomation['surveyType'],
      isShowResult: (surveyInfo.isShowResult as unknown as string) === 'false' ? false : true,
      allowedFrequency:
        (surveyInfo.allowedFrequency as unknown as string) === 'false' ? false : true,
      userID: isInfomationTabUpdate ? state.surveyInformation.userID : newUserID ? newUserID : '',
      totalBonusCodesMax: surveyInfo.totalBonusCodesMax,
      totalBonusCodesSafe: surveyInfo.totalBonusCodesSafe,
      campaignID: '',
      copySurvey: state.surveyInformation.copySurvey,
    };
    return updatedInfomation;
  };

  const transformSetSurveyInfoToSetSurveyInfo = (
    surveyInfo: IGetSurveyInfomation
  ): IGetSurveyInfomation => {
    const { contents } = state.listOfBonusCode as IListOfBonusCode;

    const updatedInfomation: IGetSurveyInfomation = {
      ...surveyInfo,
      startDate: dayjs(
        new Date((surveyInfo.startDate as unknown as string).split('/').reverse().toString())
      ) as Dayjs,
      endDate: dayjs(
        new Date((surveyInfo.endDate as unknown as string).split('/').reverse().toString())
      ) as Dayjs,
      isShowResult: surveyInfo.isShowResult ? 'true' : 'false',
      allowedFrequency: surveyInfo.allowedFrequency ? 'true' : 'false',
      surveyBonusCodes: contents,
      surveyViewers: Array.isArray(surveyInfo.surveyViewers) ? surveyInfo.surveyViewers : [],
      apps: Array.isArray(surveyInfo.apps) ? surveyInfo.apps : [],
      departments: Array.isArray(surveyInfo.departments) ? surveyInfo.departments : [],
      survey360Objects: Array.isArray(surveyInfo.survey360Objects)
        ? surveyInfo.survey360Objects
        : [],
      userCanViewSurvey: Array.isArray(surveyInfo.userCanViewSurvey)
        ? surveyInfo.userCanViewSurvey
        : [],
      userCanUpdateSurvey: Array.isArray(surveyInfo.userCanUpdateSurvey)
        ? surveyInfo.userCanUpdateSurvey
        : [],
    };

    return updatedInfomation;
  };

  const transformDataSurveyFilter = (filterObj: IParamFilterEvaluatedQuestionProps) => {
    return {
      regionIDs: Array.isArray(filterObj.regionIDs) ? filterObj.regionIDs : [],
      unitIDs: Array.isArray(filterObj.unitIDs) ? filterObj.unitIDs : [],
      divisionIDs: Array.isArray(filterObj.divisionIDs) ? filterObj.divisionIDs : [],
      restaurantsIDs: Array.isArray(filterObj.restaurantsIDs) ? filterObj.restaurantsIDs : [],
      positionIDs: Array.isArray(filterObj.positionIDs) ? filterObj.positionIDs : [],
      levelIDs: Array.isArray(filterObj.levelIDs) ? filterObj.levelIDs : [],
      departmentIDs: Array.isArray(filterObj.departmentIDs) ? filterObj.departmentIDs : [],
    };
  };

  /**Helper Function*/

  const handleLogicEvaluatedQuestion = async (groupQuestions: ISectionGroup | null) => {
    const initGroup = {
      [SurveyConst.INIT_GROUP_QUESTION]: {
        sectionName: '',
        question: [],
      },
    } as ISectionGroup;
    const currentGroupQuestion = groupQuestions ? groupQuestions : initGroup;
    const evaluatedQuestion = findQuestionArrByField(
      groupQuestions,
      mappingSelectType.evaluated,
      'questionTypeID'
    );
    if (currentSurveyType.current === surveyTypeConstant.normal) {
      // case 360 -> normal -> remove evaluated question
      if (evaluatedQuestion && evaluatedQuestion[0] && currentGroupQuestion) {
        currentGroupQuestion[SurveyConst.INIT_GROUP_QUESTION].question.shift();
      }
      return currentGroupQuestion;
    }
    const isExits360Question = await CheckQuestion360Exist({
      surveyID: state.surveyInformation.surveyID,
      questionID: evaluatedQuestionID,
    });

    handleSetIsEvaluatedQuestionExist(isExits360Question);
    /*
       Logic handle in FE
        + Evaluated question has questionID -> call api update
        + Evaluated question no questionID -> call api create
     */
    if (!isExits360Question) {
      //case no exists evaluated question in database
      if (
        Array.isArray(evaluatedQuestion) &&
        evaluatedQuestion.length > 0 &&
        evaluatedQuestion[0].questionID
      ) {
        //case exists evaluated question in FE -> remove it.
        currentGroupQuestion[SurveyConst.INIT_GROUP_QUESTION].question[0] =
          initQuestionEvaluatedWhenUpdate;
        handleAddGroupQuestion(currentGroupQuestion);
        return currentGroupQuestion;
      }

      if (!Array.isArray(evaluatedQuestion) || evaluatedQuestion.length === 0) {
        //case no exists evaluated question in FE -> create new evaluated question
        currentGroupQuestion[SurveyConst.INIT_GROUP_QUESTION].question.unshift(
          initQuestionEvaluatedWhenUpdate
        );
        return currentGroupQuestion;
      }
    } else {
      //case exists evaluated question in database
      if (!Array.isArray(evaluatedQuestion) || evaluatedQuestion.length === 0) {
        //case no exists evaluated question in FE -> create new evaluated question
        currentGroupQuestion[SurveyConst.INIT_GROUP_QUESTION].question.unshift({
          ...initQuestionEvaluatedWhenUpdate,
          questionID: evaluatedQuestionID,
        });
        return currentGroupQuestion;
      }
      if (
        Array.isArray(evaluatedQuestion) &&
        evaluatedQuestion.length > 0 &&
        !evaluatedQuestion[0].questionID
      ) {
        //case exists evaluated question in FE(but no questionID) -> add questionID
        currentGroupQuestion[SurveyConst.INIT_GROUP_QUESTION].question[0] = {
          ...initQuestionEvaluatedWhenUpdate,
          questionID: evaluatedQuestionID,
        };
        return currentGroupQuestion;
      }
    }
    return currentGroupQuestion;
  };

  const fetchSurveyQuestionByID = useCallback(
    async (surveyID?: string) => {
      try {
        const response = await getSurveyQuestionByID(
          surveyID ? surveyID : state.surveyInformation.surveyID
        );

        const formattedSectionGroup = transformSurveyQuestionIntoGroupedQuestion(response);

        const formatEvaluatedQuestions = await handleLogicEvaluatedQuestion(formattedSectionGroup);

        handleAddGroupQuestion(formatEvaluatedQuestions);
        handleSetSurveyDataSave({
          groupQuestions: true,
        });
        if (response && response.length > 0) {
          setContentTabUpdate(true);
        }
      } catch (error: any) {
        messageError(error.response, errorNotification);
      }
    },
    [
      state.currentTab,
      state.surveyInformation.surveyID,
      state.surveyTypeForm,
      state.isCopySurvey,
      state.isLoading,
      currentSurveyType.current,
      evaluatedQuestionID,
      initQuestionEvaluatedWhenUpdate,
    ]
  );

  const closeUploadModalThenUpdatingTab2 = async () => {
    try {
      setLoadingOn();
      handleCloseModal({ type: 'upload-survey-question' });
      await fetchSurveyQuestionByID();
    } finally {
      setLoadingOff();
    }
  };

  const checkIsResetMemberList = (
    currentSurveyInfo: IGetSurveyInfomation,
    newSurveyInfo: IGetSurveyInfomation
  ) => {
    if (currentSurveyInfo.surveyType !== newSurveyInfo.surveyType) {
      return actionUpdateStaffsConstant.CLEAR_STATE;
    }
    if (!isEqual(currentSurveyInfo.survey360Objects, newSurveyInfo.survey360Objects)) {
      return actionUpdateStaffsConstant.CLEAR_STATE;
    }
    return actionUpdateStaffsConstant.KEEP_STATE;
  };

  const getDuplicateStaffToastMessage = (surveyInfoTab1: any) => {
    const duplicateStaffs = Array.isArray(surveyInfoTab1?.duplicateStaffs)
      ? surveyInfoTab1.duplicateStaffs
      : [];

    return (
      surveyInfoTab1?.message ||
      'Không thể thực hiện do có thành viên thuộc bài khảo sát khác trong khoảng thời gian này.'
    );
  };

  const postSurveyInformation = async (params?: IGetSurveyInfomation, isRetry?: boolean) => {
    const surveyInfomationFnc = isInfomationTabUpdate
      ? updateSurveyInfomationApi
      : postSurveyInformationApi;

    const inputData = params ? params : state.surveyInformation;
    const surveyInfo = transformGetSurveyInfoToSetSurveyInfo(inputData);
    if (surveyInfo.totalBonusCodesSafe > surveyInfo.totalBonusCodesMax) {
      if (state.currentTab === 'information') {
        errorNotification(ERROR_BONUS_CODE);
      }

      return;
    }

    try {
      if (surveyInfo.startDate !== 'Invalid Date' || surveyInfo.endDate !== 'Invalid Date') {
        const surveyInfoTab1 = await surveyInfomationFnc(surveyInfo);

        if ((surveyInfoTab1 as any).statusCode === 400 && (surveyInfoTab1 as any).errorCode === 1) {
          currentSurveyForm.current = surveyInfoTab1.surveyForm;
          return surveyInfoTab1;
        }

        const formattedSurveyInfomation = transformSetSurveyInfoToSetSurveyInfo(surveyInfoTab1);
        if (currentSurveyType.current !== surveyInfoTab1.surveyType) {
          currentSurveyType.current = surveyInfoTab1.surveyType;
        }
        currentSurveyForm.current = formattedSurveyInfomation.surveyForm;

        if (
          state.surveyInformation.surveyType === surveyTypeConstant.survey360 &&
          formattedSurveyInfomation.surveyType === surveyTypeConstant.normal &&
          state.surveyInformation.surveyID
        ) {
          try {
            await deleteQuestion360({
              questionID: `00000000_${formattedSurveyInfomation.surveyID}`,
              surveyID: formattedSurveyInfomation.surveyID,
            });
          } catch (error) {
            console.log('error', error);
          }
        }

        isResetStaff.current = checkIsResetMemberList(
          state.surveyInformation,
          formattedSurveyInfomation
        );

        const selectedSurveyViewersID = formattedSurveyInfomation.surveyViewers.map(
          (v) => v.viewerID
        );
        const selectedSurveyViewers = listOfUserReview.reduce<ISurveyUserReview[]>((acc, cur) => {
          if (selectedSurveyViewersID.includes(cur.viewerID)) {
            acc.push({
              id: null,
              surveyID: '',
              viewerID: cur.viewerID,
              viewerName: cur.viewerName,
              viewerDetail: cur.viewerDetail,
            });
          }
          return acc;
        }, []);

        handleSetSurveyInformation({
          ...formattedSurveyInfomation,
          surveyViewers:
            listOfUserReview.length === selectedSurveyViewers.length
              ? selectedSurveyViewers.concat([allOptionUserViewer])
              : selectedSurveyViewers,
        });
        handleSetSurveyDataSave({
          surveyInformation: true,
        });
        const notification = !isInfomationTabUpdate ? SUCCESS_ADD_CONTENT : SUCCESS_EDIT_CONTENT;
        if (state.currentTab === 'information') {
          successNotification(notification);
        }
        setInfomationTabUpdate(true);
        if (!isInfomationTabUpdate) {
          if (surveyInfoTab1.surveyType === 2) {
            const { departments: departmentsFromInfoTab1, surveyID } = surveyInfoTab1;
            const initQuestionEvaluated = defaultQuestionEvaluated(
              departmentsFromInfoTab1 as IDepartment[],
              surveyID as string
            );
          }
        }

        if (
          location &&
          location.pathname.includes(SURVEY_ADD) &&
          surveyInfoTab1.surveyID &&
          !state.isOpenModalConfirmExitEditSurvey
        ) {
          navigate({
            pathname: `/${SURVEY_LIST_PATH}/${SURVEY_EDIT}`,
            search: createSearchParams({
              surveyId: surveyInfoTab1.surveyID as string,
            }).toString(),
          });
        }
      }
    } catch (error: any) {
      messageError(error.response, errorNotification);
    }
  };

  const postSurveyAddQuestions = async () => {
    const evaluatedQuestion = findQuestionArrByField(
      state.groupQuestions,
      mappingSelectType.evaluated,
      'questionTypeID'
    );
    if (state.surveyTypeForm === 1 && evaluatedQuestion && evaluatedQuestion.length > 0) {
      handleRemoveQuestionInGroup(SurveyConst.INIT_GROUP_QUESTION, evaluatedQuestion[0].questionID);
    }

    const formattedParameter = transformGroupQuestionsToParentQuestions();

    if (!formattedParameter) return;

    const surveyQuestionFnc = isContentTabUpdate
      ? updateSurveyAddQuestionApi
      : postSurveyAddQuestionApi;
    try {
      await surveyQuestionFnc(formattedParameter);
      await fetchSurveyQuestionByID();
      if (state.currentTab === 'content') {
        successNotification(SUCCESS_EDIT_CONTENT);
      }
    } catch (error: any) {
      messageError(error.response, errorNotification);
    }
  };

  const mapGroupType = (list: keyof IGetSurveyMemberGroupFilter, order: number) => {
    return (
      state.surveyMemberGroupFilter[list]?.map((x: any) => ({
        objectGroupID: x,
        objectGroupType: order,
      })) || []
    );
  };

  const postSurveyMemberList = async (
    surveyForm: number,
    resetStaff = 0,
    updateInfoError?: TUpdateInfoError
  ) => {
    if (surveyForm === surveyFormConstant.public) {
      //if survey public not call api
      return;
    }
    if (isOrgUnitMemberSurvey(state.surveyInformation)) {
      // GSURVEY-732: thành viên theo đơn vị do OrgUnitMemberProvider lưu (chạy nền)
      await runOrgUnitMemberSave();
      return;
    }
    // staffs: formatSurveyMemberListSelected.map((item: any) => ({
    //   staffID: item?.staffID,
    // })),
    //change flow -> k post xuống nhân viên đối với khảo sát 360

    const paramUser = {
      surveyID: state?.surveyInformation?.surveyID,
      staffs: [],
      resetStaff: resetStaff,
    };
    if (state.memberObjectGroup === 1 && state.surveyInformation.surveyType === 1) {
      const staffIDArr = state.surveyMemberList.reduce((acc: any, cur: any) => {
        if (cur.staffID) {
          acc.push({ staffID: cur.staffID });
        }
        return acc;
      }, []);
      paramUser.staffs = staffIDArr;
    }

    const paramGroup: ISurveyGroupAddList = {
      surveyID: state.surveyInformation.surveyID,
      objectGroups: [],
    };

    //case handle data member group
    if (state.memberObjectGroup === 2) {
      //regions
      const ddlRegionCurrentList = state.memberGroupInfo.regionGroup.requestInfo.keySearch
        ? state.ddlRegionGroupBackup
        : ddlRegionGroup;
      const selectedRegionsList = ddlRegionCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.regions.includes(cur.regionID)) {
          acc.push(cur.regionID);
        }
        return acc;
      }, []);
      const numberRegionsSelected = helperFormatDataForCallAPI(
        selectedRegionsList.length,
        ddlRegionCurrentList.length,
        70
      );
      let formatRegions;
      switch (numberRegionsSelected) {
        case TypeSelectedOption.ALL:
          formatRegions = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage: [],
            objectGroupType: 1,
          };
          break;
        case TypeSelectedOption.MANY:
          const noSelectedList = ddlRegionCurrentList.reduce<string[]>((acc, cur) => {
            if (!selectedRegionsList.includes(cur.regionID)) {
              acc.push(cur.regionID);
            }
            return acc;
          }, []);
          formatRegions = {
            isSelectAll: true,
            objectGroupIDs: noSelectedList,
            nextPage: [],
            objectGroupType: 1,
          };
          break;
        default:
          formatRegions = {
            isSelectAll: false,
            objectGroupIDs: selectedRegionsList,
            nextPage: [],
            objectGroupType: 1,
          };
          break;
      }

      //units

      const ddlUnitCurrentList = state.memberGroupInfo.unitGroup.requestInfo.keySearch
        ? state.ddlUnitGroupBackup
        : ddlQuestionUnitGroup;

      const selectedUnitsList = ddlUnitCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.units.includes(cur.unitID)) {
          acc.push(cur.unitID);
        }
        return acc;
      }, []);
      const numberUnitsSelected = helperFormatDataForCallAPI(
        selectedUnitsList.length,
        ddlUnitCurrentList.length,
        70
      );
      const notUnitsSelectedList = ddlUnitCurrentList.reduce<string[]>((acc, cur) => {
        if (!selectedUnitsList.includes(cur.unitID)) {
          acc.push(cur.unitID);
        }
        return acc;
      }, []);
      const nextPageUnitsArray = generateArrayString(
        state.memberGroupInfo.unitGroup.responseInfo.page + 1,
        state.memberGroupInfo.unitGroup.responseInfo.totalPage + 1
      );
      let formatUnits;
      if (state.memberGroupInfo.unitGroup.isSelectAllOption) {
        //case checked 'all' option
        if (
          notUnitsSelectedList.length === state.memberGroupInfo.unitGroup.responseInfo.totalItem
        ) {
          //case checked 'all' option and remove all  option in current list

          formatUnits = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage:
              state.memberGroupInfo.unitGroup.responseInfo.page + 1 <
              state.memberGroupInfo.unitGroup.responseInfo.totalPage
                ? nextPageUnitsArray
                : [],
            objectGroupType: 2,
          };
        } else {
          switch (numberUnitsSelected) {
            //case checked 'all' option and do not thing
            case TypeSelectedOption.ALL:
              formatUnits = {
                isSelectAll: true,
                objectGroupIDs: [],
                nextPage: [],
                objectGroupType: 2,
              };
              break;
            case TypeSelectedOption.MANY:
              //case checked 'all' option and remove some option
              formatUnits = {
                isSelectAll: true,
                objectGroupIDs: notUnitsSelectedList,

                nextPage:
                  state.memberGroupInfo.unitGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.unitGroup.responseInfo.totalPage
                    ? nextPageUnitsArray
                    : [],
                objectGroupType: 2,
              };
              break;
            default:
              //case checked 'all' option and remove many option
              formatUnits = {
                isSelectAll: false,
                objectGroupIDs: selectedUnitsList,
                nextPage:
                  state.memberGroupInfo.unitGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.unitGroup.responseInfo.totalPage
                    ? nextPageUnitsArray
                    : [],
                objectGroupType: 2,
              };
              break;
          }
        }
      } else {
        switch (numberUnitsSelected) {
          //case choose all option
          case TypeSelectedOption.ALL:
            formatUnits = {
              isSelectAll: true,
              objectGroupIDs: [],
              nextPage: [],
              objectGroupType: 2,
            };
            break;
          case TypeSelectedOption.MANY:
            //case choose many option
            formatUnits = {
              isSelectAll: true,
              objectGroupIDs: notUnitsSelectedList,
              nextPage: [],
              objectGroupType: 2,
            };
            break;
          default:
            formatUnits = {
              isSelectAll: false,
              objectGroupIDs: selectedUnitsList,
              nextPage: [],
              objectGroupType: 2,
            };
            break;
        }
      }

      //departments
      const ddlDepartmentCurrentList = state.memberGroupInfo.departmentGroup.requestInfo.keySearch
        ? state.ddlDepartmentGroupBackup
        : ddlDepartmentGroup;
      const selectedDepartmentsList = ddlDepartmentCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.departments.includes(cur.departmentID)) {
          acc.push(cur.departmentID);
        }
        return acc;
      }, []);
      const numberDepartmentsSelected = helperFormatDataForCallAPI(
        selectedDepartmentsList.length,
        ddlDepartmentCurrentList.length,
        70
      );
      const notDepartmentsSelectedList = ddlDepartmentCurrentList.reduce<string[]>((acc, cur) => {
        if (!selectedDepartmentsList.includes(cur.departmentID)) {
          acc.push(cur.departmentID);
        }
        return acc;
      }, []);
      const nextPageDepartmentsArray = generateArrayString(
        state.memberGroupInfo.departmentGroup.responseInfo.page + 1,
        state.memberGroupInfo.departmentGroup.responseInfo.totalPage + 1
      );
      let formatDepartments;
      if (state.memberGroupInfo.departmentGroup.isSelectAllOption) {
        //case checked 'all' option
        if (
          notDepartmentsSelectedList.length ===
          state.memberGroupInfo.departmentGroup.responseInfo.totalItem
        ) {
          //case checked 'all' option and remove all  option in current list
          formatDepartments = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage:
              state.memberGroupInfo.departmentGroup.responseInfo.page + 1 <
              state.memberGroupInfo.departmentGroup.responseInfo.totalPage
                ? nextPageDepartmentsArray
                : [],
            objectGroupType: 3,
          };
        } else {
          switch (numberDepartmentsSelected) {
            //case checked 'all' option and do not thing
            case TypeSelectedOption.ALL:
              formatDepartments = {
                isSelectAll: true,
                objectGroupIDs: [],
                nextPage: [],
                objectGroupType: 3,
              };
              break;
            case TypeSelectedOption.MANY:
              //case checked 'all' option and remove some option
              formatDepartments = {
                isSelectAll: true,
                objectGroupIDs: notDepartmentsSelectedList,
                nextPage:
                  state.memberGroupInfo.departmentGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.departmentGroup.responseInfo.totalPage
                    ? nextPageDepartmentsArray
                    : [],
                objectGroupType: 3,
              };
              break;
            default:
              //case checked 'all' option and remove many option
              formatDepartments = {
                isSelectAll: false,
                objectGroupIDs: selectedDepartmentsList,
                nextPage:
                  state.memberGroupInfo.departmentGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.departmentGroup.responseInfo.totalPage
                    ? nextPageDepartmentsArray
                    : [],
                objectGroupType: 3,
              };
              break;
          }
        }
      } else {
        switch (numberDepartmentsSelected) {
          //case choose all option
          case TypeSelectedOption.ALL:
            formatDepartments = {
              isSelectAll: true,
              objectGroupIDs: [],
              nextPage: [],
              objectGroupType: 3,
            };
            break;
          case TypeSelectedOption.MANY:
            //case choose many option
            formatDepartments = {
              isSelectAll: true,
              objectGroupIDs: notDepartmentsSelectedList,
              nextPage: [],
              objectGroupType: 3,
            };
            break;
          default:
            formatDepartments = {
              isSelectAll: false,
              objectGroupIDs: selectedDepartmentsList,
              nextPage: [],
              objectGroupType: 3,
            };
            break;
        }
      }

      //divisions
      const ddlDivisionCurrentList = state.memberGroupInfo.divisionGroup.requestInfo.keySearch
        ? state.ddlDivisionGroupBackup
        : ddlDivisionGroup;
      const selectedDivisionsList = ddlDivisionCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.divisions.includes(cur.divisionID)) {
          acc.push(cur.divisionID);
        }
        return acc;
      }, []);
      const numberDivisionsSelected = helperFormatDataForCallAPI(
        selectedDivisionsList.length,
        ddlDivisionCurrentList.length,
        70
      );
      const notDivisionsSelectedList = ddlDivisionCurrentList.reduce<string[]>((acc, cur) => {
        if (!selectedDivisionsList.includes(cur.divisionID)) {
          acc.push(cur.divisionID);
        }
        return acc;
      }, []);
      const nextPageDivisionsArray = generateArrayString(
        state.memberGroupInfo.divisionGroup.responseInfo.page + 1,
        state.memberGroupInfo.divisionGroup.responseInfo.totalPage + 1
      );
      let formatDivisions;
      if (state.memberGroupInfo.divisionGroup.isSelectAllOption) {
        //case checked 'all' option
        if (
          notDepartmentsSelectedList.length ===
          state.memberGroupInfo.divisionGroup.responseInfo.totalItem
        ) {
          //case checked 'all' option and remove all  option in current list
          formatDivisions = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage:
              state.memberGroupInfo.divisionGroup.responseInfo.page + 1 <
              state.memberGroupInfo.divisionGroup.responseInfo.totalPage
                ? nextPageDivisionsArray
                : [],
            objectGroupType: 4,
          };
        } else {
          switch (numberDivisionsSelected) {
            //case checked 'all' option and do not thing
            case TypeSelectedOption.ALL:
              formatDivisions = {
                isSelectAll: true,
                objectGroupIDs: [],
                nextPage: [],
                objectGroupType: 4,
              };
              break;
            case TypeSelectedOption.MANY:
              //case checked 'all' option and remove some option
              formatDivisions = {
                isSelectAll: true,
                objectGroupIDs: notDivisionsSelectedList,
                nextPage:
                  state.memberGroupInfo.divisionGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.divisionGroup.responseInfo.totalPage
                    ? nextPageDivisionsArray
                    : [],
                objectGroupType: 4,
              };
              break;
            default:
              //case checked 'all' option and remove many option
              formatDivisions = {
                isSelectAll: false,
                objectGroupIDs: selectedDivisionsList,
                nextPage:
                  state.memberGroupInfo.divisionGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.divisionGroup.responseInfo.totalPage
                    ? nextPageDivisionsArray
                    : [],
                objectGroupType: 4,
              };
              break;
          }
        }
      } else {
        switch (numberDivisionsSelected) {
          //case choose all option
          case TypeSelectedOption.ALL:
            formatDivisions = {
              isSelectAll: true,
              objectGroupIDs: [],
              nextPage: [],
              objectGroupType: 4,
            };
            break;
          case TypeSelectedOption.MANY:
            //case choose many option
            formatDivisions = {
              isSelectAll: true,
              objectGroupIDs: notDivisionsSelectedList,
              nextPage: [],
              objectGroupType: 4,
            };
            break;
          default:
            formatDivisions = {
              isSelectAll: false,
              objectGroupIDs: selectedDivisionsList,
              nextPage: [],
              objectGroupType: 4,
            };
            break;
        }
      }

      //restaurants
      const ddlRestaurantCurrentList = state.memberGroupInfo.restaurantGroup.requestInfo.keySearch
        ? state.ddlRestaurantGroupBackup
        : ddlRestaurantGroup;
      const selectedRestaurantsList = ddlRestaurantCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.restaurants.includes(cur.restaurantID)) {
          acc.push(cur.restaurantID);
        }
        return acc;
      }, []);
      const numberRestaurantsSelected = helperFormatDataForCallAPI(
        selectedRestaurantsList.length,
        ddlRestaurantCurrentList.length,
        70
      );
      const notRestaurantsSelectedList = ddlRestaurantCurrentList.reduce<string[]>((acc, cur) => {
        if (!selectedRestaurantsList.includes(cur.restaurantID)) {
          acc.push(cur.restaurantID);
        }
        return acc;
      }, []);
      const nextPageRestaurantsArray = generateArrayString(
        state.memberGroupInfo.restaurantGroup.responseInfo.page + 1,
        state.memberGroupInfo.restaurantGroup.responseInfo.totalPage + 1
      );
      let formatRestaurants;
      if (state.memberGroupInfo.restaurantGroup.isSelectAllOption) {
        //case checked 'all' option
        if (
          notDepartmentsSelectedList.length ===
          state.memberGroupInfo.restaurantGroup.responseInfo.totalItem
        ) {
          //case checked 'all' option and remove all  option in current list
          formatRestaurants = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage:
              state.memberGroupInfo.restaurantGroup.responseInfo.page + 1 <
              state.memberGroupInfo.restaurantGroup.responseInfo.totalPage
                ? nextPageRestaurantsArray
                : [],
            objectGroupType: 5,
          };
        } else {
          switch (numberRestaurantsSelected) {
            //case checked 'all' option and do not thing
            case TypeSelectedOption.ALL:
              formatRestaurants = {
                isSelectAll: true,
                objectGroupIDs: [],
                nextPage: [],
                objectGroupType: 5,
              };
              break;
            case TypeSelectedOption.MANY:
              //case checked 'all' option and remove some option
              formatRestaurants = {
                isSelectAll: true,
                objectGroupIDs: notRestaurantsSelectedList,
                nextPage:
                  state.memberGroupInfo.restaurantGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.restaurantGroup.responseInfo.totalPage
                    ? nextPageRestaurantsArray
                    : [],
                objectGroupType: 5,
              };
              break;
            default:
              //case checked 'all' option and remove many option
              formatRestaurants = {
                isSelectAll: false,
                objectGroupIDs: selectedRestaurantsList,
                nextPage:
                  state.memberGroupInfo.restaurantGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.restaurantGroup.responseInfo.totalPage
                    ? nextPageRestaurantsArray
                    : [],
                objectGroupType: 5,
              };
              break;
          }
        }
      } else {
        switch (numberRestaurantsSelected) {
          //case choose all option
          case TypeSelectedOption.ALL:
            formatRestaurants = {
              isSelectAll: true,
              objectGroupIDs: [],
              nextPage: [],
              objectGroupType: 5,
            };
            break;
          case TypeSelectedOption.MANY:
            //case choose many option
            formatRestaurants = {
              isSelectAll: true,
              objectGroupIDs: notRestaurantsSelectedList,
              nextPage: [],
              objectGroupType: 5,
            };
            break;
          default:
            formatRestaurants = {
              isSelectAll: false,
              objectGroupIDs: selectedRestaurantsList,
              nextPage: [],
              objectGroupType: 5,
            };
            break;
        }
      }

      //positions
      const ddlPositionCurrentList = state.memberGroupInfo.positionGroup.requestInfo.keySearch
        ? state.ddlPositionGroupBackup
        : ddlQuestionPositionGroup;
      const selectedPositionsList = ddlPositionCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.positions.includes(cur.positionID)) {
          acc.push(cur.positionID);
        }
        return acc;
      }, []);
      const numberPositionsSelected = helperFormatDataForCallAPI(
        selectedPositionsList.length,
        ddlPositionCurrentList.length,
        70
      );
      const notPositionsSelectedList = ddlPositionCurrentList.reduce<string[]>((acc, cur) => {
        if (!selectedDivisionsList.includes(cur.positionID)) {
          acc.push(cur.positionID);
        }
        return acc;
      }, []);
      const nextPagePositionsArray = generateArrayString(
        state.memberGroupInfo.positionGroup.responseInfo.page + 1,
        state.memberGroupInfo.positionGroup.responseInfo.totalPage + 1
      );
      let formatPositions;
      if (state.memberGroupInfo.positionGroup.isSelectAllOption) {
        //case checked 'all' option
        if (
          notDepartmentsSelectedList.length ===
          state.memberGroupInfo.positionGroup.responseInfo.totalItem
        ) {
          //case checked 'all' option and remove all  option in current list
          formatPositions = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage:
              state.memberGroupInfo.positionGroup.responseInfo.page + 1 <
              state.memberGroupInfo.positionGroup.responseInfo.totalPage
                ? nextPagePositionsArray
                : [],
            objectGroupType: 6,
          };
        } else {
          switch (numberPositionsSelected) {
            //case checked 'all' option and do not thing
            case TypeSelectedOption.ALL:
              formatPositions = {
                isSelectAll: true,
                objectGroupIDs: [],
                nextPage: [],
                objectGroupType: 6,
              };
              break;
            case TypeSelectedOption.MANY:
              //case checked 'all' option and remove some option
              formatPositions = {
                isSelectAll: true,
                objectGroupIDs: notPositionsSelectedList,
                nextPage:
                  state.memberGroupInfo.positionGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.positionGroup.responseInfo.totalPage
                    ? nextPagePositionsArray
                    : [],
                objectGroupType: 6,
              };
              break;
            default:
              //case checked 'all' option and remove many option
              formatPositions = {
                isSelectAll: false,
                objectGroupIDs: selectedPositionsList,
                nextPage:
                  state.memberGroupInfo.positionGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.positionGroup.responseInfo.totalPage
                    ? nextPagePositionsArray
                    : [],
                objectGroupType: 6,
              };
              break;
          }
        }
      } else {
        switch (numberPositionsSelected) {
          //case choose all option
          case TypeSelectedOption.ALL:
            formatPositions = {
              isSelectAll: true,
              objectGroupIDs: [],
              nextPage: [],
              objectGroupType: 6,
            };
            break;
          case TypeSelectedOption.MANY:
            //case choose many option
            formatPositions = {
              isSelectAll: true,
              objectGroupIDs: notPositionsSelectedList,
              nextPage: [],
              objectGroupType: 6,
            };
            break;
          default:
            formatPositions = {
              isSelectAll: false,
              objectGroupIDs: selectedPositionsList,
              nextPage: [],
              objectGroupType: 6,
            };
            break;
        }
      }

      //levels
      const ddlLevelCurrentList = state.memberGroupInfo.levelGroup.requestInfo.keySearch
        ? state.ddlLevelGroupBackup
        : ddlQuestionLevelGroup;

      const selectedLevelsList = ddlLevelCurrentList.reduce<string[]>((acc, cur) => {
        if (state.surveyMemberGroupFilter.levels.includes(cur.levelID)) {
          acc.push(cur.levelID);
        }
        return acc;
      }, []);
      const numberLevelsSelected = helperFormatDataForCallAPI(
        selectedLevelsList.length,
        ddlLevelCurrentList.length,
        70
      );
      const notLevelsSelectedList = ddlLevelCurrentList.reduce<string[]>((acc, cur) => {
        if (!selectedDivisionsList.includes(cur.levelID)) {
          acc.push(cur.levelID);
        }
        return acc;
      }, []);
      const nextPageLevelsArray = generateArrayString(
        state.memberGroupInfo.levelGroup.responseInfo.page + 1,
        state.memberGroupInfo.levelGroup.responseInfo.totalPage + 1
      );
      let formatLevels;
      if (state.memberGroupInfo.levelGroup.isSelectAllOption) {
        //case checked 'all' option
        if (
          notDepartmentsSelectedList.length ===
          state.memberGroupInfo.levelGroup.responseInfo.totalItem
        ) {
          //case checked 'all' option and remove all  option in current list
          formatLevels = {
            isSelectAll: true,
            objectGroupIDs: [],
            nextPage:
              state.memberGroupInfo.levelGroup.responseInfo.page + 1 <
              state.memberGroupInfo.levelGroup.responseInfo.totalPage
                ? nextPageLevelsArray
                : [],
            objectGroupType: 7,
          };
        } else {
          switch (numberLevelsSelected) {
            //case checked 'all' option and do not thing
            case TypeSelectedOption.ALL:
              formatLevels = {
                isSelectAll: true,
                objectGroupIDs: [],
                nextPage: [],
                objectGroupType: 7,
              };
              break;
            case TypeSelectedOption.MANY:
              //case checked 'all' option and remove some option
              formatLevels = {
                isSelectAll: true,
                objectGroupIDs: notLevelsSelectedList,
                nextPage:
                  state.memberGroupInfo.levelGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.levelGroup.responseInfo.totalPage
                    ? nextPageLevelsArray
                    : [],
                objectGroupType: 7,
              };
              break;
            default:
              //case checked 'all' option and remove many option
              formatLevels = {
                isSelectAll: false,
                objectGroupIDs: selectedLevelsList,
                nextPage:
                  state.memberGroupInfo.levelGroup.responseInfo.page + 1 <
                  state.memberGroupInfo.levelGroup.responseInfo.totalPage
                    ? nextPageLevelsArray
                    : [],
                objectGroupType: 7,
              };
              break;
          }
        }
      } else {
        switch (numberLevelsSelected) {
          //case choose all option
          case TypeSelectedOption.ALL:
            formatLevels = {
              isSelectAll: true,
              objectGroupIDs: [],
              nextPage: [],
              objectGroupType: 7,
            };
            break;
          case TypeSelectedOption.MANY:
            //case choose many option
            formatLevels = {
              isSelectAll: true,
              objectGroupIDs: notLevelsSelectedList,
              nextPage: [],
              objectGroupType: 7,
            };
            break;
          default:
            formatLevels = {
              isSelectAll: false,
              objectGroupIDs: selectedLevelsList,
              nextPage: [],
              objectGroupType: 7,
            };
            break;
        }
      }

      //outlook
      const formatOutlook = {
        isSelectAll: false,
        objectGroupIDs: [],
        nextPage: [],
        objectGroupType: 8,
      };
      paramGroup.objectGroups = [
        formatRegions,
        formatUnits,
        formatDepartments,
        formatDivisions,
        formatRestaurants,
        formatPositions,
        formatLevels,
        formatOutlook,
      ];
    }

    try {
      //edit
      setLoadingOn();
      if (!state.surveyInformation.surveyID) {
        setLoadingOff();
        return;
      }

      if (state.memberObjectGroup === 1) {
        let updateMemberRes: any;
        if (paramUser.staffs.length === 0) {
          //  if (state.currentTab === 'memberList') {
          //    await updateSurveyMemberListUserApi({
          //      surveyID: state?.surveyInformation?.surveyID,
          //      staffs: [],
          //      resetStaff: 1,
          //    });
          //    return;
          //  }
          updateMemberRes = await updateSurveyMemberListUserApi(paramUser);
        } else {
          let count = 0;
          let paramCallAPI;
          const numberOfRuns = Math.ceil(paramUser.staffs.length / maxRecordLength);
          for (let i = 1; i <= numberOfRuns; i++) {
            paramCallAPI = {
              surveyID: state?.surveyInformation?.surveyID,
              staffs: paramUser.staffs.slice(count, count + maxRecordLength),
            };
            count = count + maxRecordLength;
            updateMemberRes = await updateSurveyMemberListUserApi(paramCallAPI);
          }

          //clear data in tab 360 memberList when changing surveyType
          if (state.surveyInformation.surveyType === 2 && state.currentTab === 'information') {
            handleSetMemberListAll([]);
            handleSetMemberListAll360([]);
            handleSetMemberList([]);
            handleSetMemberListAll([]);
          }
        }

        const isDuplicateStaffHandled = await handleDuplicateStaffConflictForApp({
          updateInfoError,
          updateMemberRes,
          appID: surveyAppIDConstant.guongThan,
          handleDuplicateStaffError,
          retryPostSurveyInformation: postSurveyInformation,
        });
        if (isDuplicateStaffHandled) {
          return;
        }
      } else if (state.memberObjectGroup === 3) {
        await updateSurveyMemberListAllCompanyApi({
          surveyID: state?.surveyInformation?.surveyID,
        });
      } else {
        await updateSurveyMemberListGroupApi(paramGroup);
      }
      handleSetSurveyDataSave({
        surveyMemberList: true,
      });
      if (state.currentTab === 'memberList') {
        successNotification(SUCCESS_EDIT_CONTENT);
      }

      if (resetStaff === actionUpdateStaffsConstant.CLEAR_STATE && !state.isMemberList360Changed) {
        handleSetIsMemberList360Changed(true);
      }
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  };

  const handleUpdateAllTabs = async (params?: IGetSurveyInfomation) => {
    setLoadingOn();
    try {
      // do something

      const updateInfoError = await postSurveyInformation(params);
      // GSURVEY-732: luồng thành viên theo đơn vị không đi qua modal trùng thành viên
      // trong postSurveyMemberList → mở modal tại đây và dừng lưu các tab còn lại
      if (
        isOrgUnitMemberSurvey(state.surveyInformation) &&
        handleDuplicateStaffError(updateInfoError as any)
      ) {
        return;
      }
      await postSurveyAddQuestions();
      await postSurveyMemberList(currentSurveyForm.current, isResetStaff.current, {
        ...updateInfoError,
        params: params || state.surveyInformation,
      });
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  };

  const fetchInformationTabDDLData = async () => {
    const objQueryParams: {
      currentTab?: string;
      surveyId?: string;
    } = location.search
      .slice(1)
      .split('&')
      .map((p) => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    const surveyId = objQueryParams?.surveyId;
    try {
      const ddlApp = await getDdlEmbedAppApi();
      if (!surveyId) {
        const currentUserID = handleGetUSerID();
        const timeNow = dayjs(new Date());
        const reqDepartments = getDDLDepartmentApi({
          units: [],
          selectDepartmentIDs: [],
        });
        const reqSurveyReview = getDDLResultUserApi();
        const [resDeparts, resSurveyReview] = await Promise.all([reqDepartments, reqSurveyReview]);
        const defaultUserViewer = Array.isArray(resSurveyReview)
          ? resSurveyReview.reduce<ISurveyViewers[]>((acc, cur) => {
              if (cur.conditionID === currentUserID) {
                acc.push({
                  id: null,
                  surveyID: '',
                  viewerID: cur.conditionID,
                  viewerName: cur.conditionName,
                  viewerDetail: cur.conditionTextDetail,
                });
              }
              return acc;
            }, [])
          : [];
        setDdlDepartment(Array.isArray(resDeparts) ? resDeparts : []);
        setListOfUserReivew(
          Array.isArray(resSurveyReview)
            ? resSurveyReview.map<ISurveyUserReview>((user) => ({
                id: null,
                surveyID: '',
                viewerID: user.conditionID,
                viewerName: user.conditionName,
                viewerDetail: user.conditionTextDetail,
              }))
            : []
        );

        handleSetSurveyInformation({
          ...state.surveyInformation,
          surveyViewers: defaultUserViewer,
          startDate: timeNow,
        });
      }
      setDdlEmbedApp(ddlApp);
    } catch (error: any) {
      messageError(error.response, errorNotification);
    }
  };

  const fetchTab3DataMember = async () => {
    if (
      ddlRegion.length > 0 ||
      ddlQuestionUnit.length > 0 ||
      ddlDivision.length > 0 ||
      ddlQuestionUsers.length > 0
      // k set phong ban vi tab 1 đã có
    )
      return;

    try {
      const p3 = getDDLQuestionRegionApi({
        surveyID: state.surveyInformation.surveyID ? state.surveyInformation.surveyID : null,
        selectRegionIDs: [],
      });
      const p4 = getDDLQuestionUsersApi();
      // const p5 = getDDLQuestionLevelsApi({
      //   surveyID: state.surveyInformation.surveyID ? state.surveyInformation.surveyID : null,
      //   selectLevelIDs: [],
      // });

      const p7 = getDDLQuestionUnitsApi({
        regions: [],
        selectUnitIDs: [],
      });

      const [rs3, rs4, rs7] = await Promise.all([p3, p4, p7]);
      setDdlQuestionRegions(rs3);
      setDdlQuestionUsers(rs4);
      //setDdlQuestionLevel(rs5);
      setDdlQuestionUnit(rs7);

      const department = await getDDLQuestionDepartmentApi({
        units: [],
        selectDepartmentIDs: [],
      });
      setDdlDepartment(department);

      const rs9 = await getDDLDivisionApi({
        departments: [],
        selectDivisionIDs: [],
      });
      setDdlDivision(rs9);

      const rs10 = await getDDLRestaurantApi({
        page: 1,
        pageSize: 20,
        divisions: [],
        restaurantName: '',
        surveyID: state.surveyInformation.surveyID ? state.surveyInformation.surveyID : null,
        restaurantDtos: [],
      });
      setDdlRestaurant(rs10);
    } catch (error: any) {
      messageError(error.response, errorNotification);
    }
  };

  const fetchDetailMemberList = async (
    surveyId: string,
    objectGroup: number,
    surveyType: number,
    currentSurveyInfo: IGetSurveyInfomation
  ) => {
    if (objectGroup === 1) {
      //tab 1 -detail user
      if (surveyType == 1) {
        const response = await getDetailMemberListApi(surveyId);
        const staffIDObj = response.map((item) => ({
          staffID: item.staffID,
        }));
        handleSetMemberListAll(staffIDObj);
        handleSetMemberList(response);
      }
      if (surveyType == 2) {
        const param = {
          page: 1,
          pageSize: 10,
          surveyID: surveyId,
        };
        const res = await get360SurveyMembersListApi(param);
        if (state.isMemberList360Changed) {
          handleSetIsMemberList360Changed(false);
        }
        handleSetMemberList360(res);
      }
    } else if (objectGroup === 2) {
      //tab 2 - detail group
      const res = await getDetailGroupApi(surveyId);
      const formatRegionID = res.regions.reduce<string[]>((acc, cur) => {
        if (cur.regionID !== 'All') {
          acc.push(cur.regionID);
        }
        return acc;
      }, []);
      const formatUnitID = res.units.reduce<string[]>((acc, cur) => {
        if (cur.unitID !== 'All') {
          acc.push(cur.unitID);
        }
        return acc;
      }, []);

      const formatDepartmentID = res.departments.reduce<string[]>((acc, cur) => {
        if (cur.departmentID !== 'All') {
          acc.push(cur.departmentID);
        }
        return acc;
      }, []);
      const formatDivisionID = res.divisions.reduce<string[]>((acc, cur) => {
        if (cur.divisionID !== 'All') {
          acc.push(cur.divisionID);
        }
        return acc;
      }, []);
      const formatRestaurantID = res.restaurants.reduce<string[]>((acc, cur) => {
        if (cur.restaurantID !== 'All') {
          acc.push(cur.restaurantID);
        }
        return acc;
      }, []);
      const formatPositionID = res.positions.reduce<string[]>((acc, cur) => {
        if (cur.positionID !== 'All') {
          acc.push(cur.positionID);
        }
        return acc;
      }, []);
      const formatLevelID = res.levels.reduce<string[]>((acc, cur) => {
        if (cur.levelID !== 'All') {
          acc.push(cur.levelID);
        }
        return acc;
      }, []);

      const detail: IGetSurveyMemberGroupFilter = {
        regions: formatRegionID,
        units: formatUnitID,
        departments: formatDepartmentID,
        divisions: formatDivisionID,
        restaurants: formatRestaurantID,
        positions: formatPositionID,
        levels: formatLevelID,
        outlook: [],
      };

      const isSelectedAllRegion = res.regions.some((x) => x.regionID === 'All');
      const isSelectedAllUnit = res.units.some((x) => x.unitID === 'All');
      const isSelectedAllDepartment = res.departments.some((x) => x.departmentID === 'All');
      const isSelectedAllDivision = res.divisions.some((x) => x.divisionID === 'All');
      const isSelectedAllRestaurant = res.restaurants.some((x) => x.restaurantID === 'All');
      const isSelectedAllPosition = res.positions.some((x) => x.positionID === 'All');
      const isSelectedAllLevel = res.levels.some((x) => x.levelID === 'All');

      const defaultSelectRegions = currentSurveyInfo.regionIDGroups.reduce<TConditionSelectGroup[]>(
        (acc, cur) => {
          acc.push({ conditionID: cur.regionID });
          return acc;
        },
        []
      );

      const defaultSelectUnits = currentSurveyInfo.unitIDGroups.reduce<TConditionSelectGroup[]>(
        (acc, cur) => {
          acc.push({ conditionID: cur.unitID });
          return acc;
        },
        []
      );

      const defaultSelectDepartments = currentSurveyInfo.departmentIDGroups.reduce<
        TConditionSelectGroup[]
      >((acc, cur) => {
        acc.push({ conditionID: cur.departmentID });
        return acc;
      }, []);

      const defaultSelectDivisions = currentSurveyInfo.divisionIDGroups.reduce<
        TConditionSelectGroup[]
      >((acc, cur) => {
        acc.push({ conditionID: cur.divisionID });
        return acc;
      }, []);

      const defaultSelectRestaurants = currentSurveyInfo.restaurantsIDGroups.reduce<
        TConditionSelectGroup[]
      >((acc, cur) => {
        acc.push({ conditionID: cur.restaurantID });
        return acc;
      }, []);

      const defaultSelectPositions = currentSurveyInfo.positionIDGroups.reduce<
        TConditionSelectGroup[]
      >((acc, cur) => {
        acc.push({ conditionID: cur.positionID });
        return acc;
      }, []);

      const defaultSelectLevels = currentSurveyInfo.levelIDGroups.reduce<TConditionSelectGroup[]>(
        (acc, cur) => {
          acc.push({ conditionID: cur.levelID });
          return acc;
        },
        []
      );

      const newMemberGroupInfo = {
        regionGroup: {
          ...state.memberGroupInfo.regionGroup,
          requestInfo: {
            ...state.memberGroupInfo.regionGroup.requestInfo,
            conditionSelect: defaultSelectRegions,
          },
          isSelectAllOption: isSelectedAllRegion,
        },
        unitGroup: {
          ...state.memberGroupInfo.unitGroup,
          requestInfo: {
            ...state.memberGroupInfo.unitGroup.requestInfo,
            conditionSelect: defaultSelectUnits,
          },
          isSelectAllOption: isSelectedAllUnit,
        },
        departmentGroup: {
          ...state.memberGroupInfo.departmentGroup,
          requestInfo: {
            ...state.memberGroupInfo.departmentGroup.requestInfo,
            conditionSelect: defaultSelectDepartments,
          },
          isSelectAllOption: isSelectedAllDepartment,
        },
        divisionGroup: {
          ...state.memberGroupInfo.divisionGroup,
          requestInfo: {
            ...state.memberGroupInfo.divisionGroup.requestInfo,
            conditionSelect: defaultSelectDivisions,
          },
          isSelectAllOption: isSelectedAllDivision,
        },
        restaurantGroup: {
          ...state.memberGroupInfo.restaurantGroup,
          requestInfo: {
            ...state.memberGroupInfo.restaurantGroup.requestInfo,
            conditionSelect: defaultSelectRestaurants,
          },
          isSelectAllOption: isSelectedAllRestaurant,
        },
        positionGroup: {
          ...state.memberGroupInfo.positionGroup,
          requestInfo: {
            ...state.memberGroupInfo.positionGroup.requestInfo,
            conditionSelect: defaultSelectPositions,
          },
          isSelectAllOption: isSelectedAllPosition,
        },
        levelGroup: {
          ...state.memberGroupInfo.levelGroup,
          requestInfo: {
            ...state.memberGroupInfo.levelGroup.requestInfo,
            conditionSelect: defaultSelectLevels,
          },
          isSelectAllOption: isSelectedAllLevel,
        },
        outlookMail: state.memberGroupInfo.outlookMail,
      };
      handleSetMemberGroupFilter(detail);
      handleSetMemberGroupInfo(newMemberGroupInfo);
    } else if (objectGroup === 0) {
      if (surveyType == 2) {
        const param = {
          page: 1,
          pageSize: 10,
          surveyID: surveyId,
        };
        const res = await get360SurveyMembersListApi(param);

        if (state.isMemberList360Changed) {
          handleSetIsMemberList360Changed(false);
        }
        handleSetMemberList360(res);
        handleSetMemberListAll360(res);

        // const staffIDObj2 = res?.contents?.map((item) => ({
        //   staffID: item.staffID,
        // }));
        // handleSetMemberListAll(staffIDObj2);
      }
    }
  };

  const handleCheckPermissionSurvey = (
    userCreateSurvey: string,
    userCanViewSurvey: string[],
    userCanUpdateSurvey: string[]
  ) => {
    const { userID, userGroupName, userGroupID } = getInfoUserAuth();
    const currentPath = location.pathname.split('/');
    if (!userID) {
      // userInfo not valid data
      return true;
    }
    if (currentPath.includes(SURVEY_EDIT)) {
      if (userGroupName && userGroupName.trim().toLowerCase() === 'admin') {
        // Users belonging to the admin group can be edit
        return false;
      }

      if (userGroupID && userGroupID.trim().toLowerCase() === 'admin') {
        // Users belonging to the admin group can be edit
        return false;
      }

      if (userCreateSurvey === userID) {
        //The user who created it can edit it
        return false;
      }
      if (
        Array.isArray(userCanViewSurvey) &&
        userCanViewSurvey.includes(userID) &&
        Array.isArray(userCanUpdateSurvey) &&
        userCanUpdateSurvey.includes(userID)
      ) {
        // Only users in the list of permissions to view and edit can edit
        return false;
      }

      return true;
    }
    if (currentPath.includes(SURVEY_VIEW)) {
      if (userGroupName && userGroupName.trim().toLowerCase() === 'admin') {
        // Users belonging to the admin group can be view
        return false;
      }

      if (userGroupID && userGroupID.trim().toLowerCase() === 'admin') {
        // Users belonging to the admin group can be view
        return false;
      }

      if (userID === userCreateSurvey) {
        //The user who created it can view it
        return false;
      }

      if (Array.isArray(userCanViewSurvey) && userCanViewSurvey.includes(userID)) {
        // Only users on the viewing permission list can view
        return false;
      }

      return true;
    }
    return false;
  };
  const fetchDataWhenEditing = async () => {
    const objQueryParams: {
      currentTab?: string;
      surveyId?: string;
    } = location.search
      .slice(1)
      .split('&')
      .map((p) => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

    const surveyId = objQueryParams?.surveyId;

    try {
      if (surveyId) {
        let newSurveyInformation: IGetSurveyInfomation = defaultSurveyInformation;
        const reqSurveyMainInfomation = getInformationSurvey({
          surveyID: surveyId,
          copySurvey: false,
        });

        const reqSelectedSurveyViewer = getSurveyViewers(surveyId);
        const reqSelectedSurveyDepartments = getSurveyDepartments(surveyId);
        const reqSelectedSurveyApps = getSurveyApps(surveyId);
        const reqListSurveyViewer = getDDLResultUserApi();
        const reqSurveyFilters = getFilterSurvey(surveyId);

        const [
          resSurveyMainInfo,
          resSelectedSurveyViewer,
          resSelectedSurveyDepartments,
          resSelectedSurveyApps,
          resListSurveyViewer,
          resSurveyFilters,
        ] = await Promise.all([
          reqSurveyMainInfomation,
          reqSelectedSurveyViewer,
          reqSelectedSurveyDepartments,
          reqSelectedSurveyApps,
          reqListSurveyViewer,
          reqSurveyFilters,
        ]);
        const isNoPermission = handleCheckPermissionSurvey(
          resSurveyMainInfo.userID,
          resSurveyMainInfo.userCanViewSurvey as unknown as string[],
          resSurveyMainInfo.userCanUpdateSurvey as unknown as string[]
        );
        if (isNoPermission) {
          navigate(`/${SURVEY_LIST_PATH}`);
        }

        const formattedSurveyFilters = transformDataSurveyFilter(resSurveyFilters);
        handleSetParamFiltersEvaluatedQuestion(formattedSurveyFilters);
        newSurveyInformation = {
          ...newSurveyInformation,
          ...resSurveyMainInfo,
          departments: resSelectedSurveyDepartments,
          apps: resSelectedSurveyApps,
        };

        if (resSurveyMainInfo.surveyType === surveyTypeConstant.survey360) {
          const resSurveyObject360 = await getSurveyObject360(surveyId);
          newSurveyInformation = {
            ...newSurveyInformation,
            survey360Objects: resSurveyObject360,
          };
        }

        const selectedSurveyViewersID = Array.isArray(resSelectedSurveyViewer)
          ? resSelectedSurveyViewer.map((v) => v.viewerID)
          : [];
        newSurveyInformation = {
          ...newSurveyInformation,
          surveyViewers: Array.isArray(resListSurveyViewer)
            ? resListSurveyViewer.reduce<ISurveyUserReview[]>((acc, cur) => {
                if (selectedSurveyViewersID.includes(cur.conditionID)) {
                  acc.push({
                    id: null,
                    surveyID: '',
                    viewerID: cur.conditionID || '',
                    viewerName: cur.conditionName || '',
                    viewerDetail: cur.conditionTextDetail || '',
                  });
                }
                return acc;
              }, [])
            : [],
          userCanViewSurvey: resSurveyMainInfo.userCanViewSurvey,
          userCanUpdateSurvey: resSurveyMainInfo.userCanUpdateSurvey,
        };

        const formattedSurveyInfomation =
          transformSetSurveyInfoToSetSurveyInfo(newSurveyInformation);

        setListOfUserReivew(
          Array.isArray(resListSurveyViewer)
            ? resListSurveyViewer.map<ISurveyUserReview>((user) => ({
                id: null,
                surveyID: '',
                viewerID: user.conditionID,
                viewerName: user.conditionName,
                viewerDetail: user.conditionTextDetail,
              }))
            : []
        );

        const listDepartments = await getDDLDepartmentApi({
          units: [],
          selectDepartmentIDs: Array.isArray(resSurveyFilters.departmentIDs)
            ? resSurveyFilters.departmentIDs
            : [],
        });
        setDdlDepartment(listDepartments);

        handleSetSurveyInformation(formattedSurveyInfomation);
        handleSetSurveyDataSave({
          surveyInformation: true,
          surveyMemberList: true,
        });
        handleSetSurveyTypeForm(resSurveyMainInfo.surveyType);
        if (currentSurveyType.current !== resSurveyMainInfo.surveyType) {
          currentSurveyType.current = resSurveyMainInfo.surveyType;
        }

        if (resSurveyMainInfo.surveyType === 2) {
          if (resSurveyMainInfo.objectGroup !== 1) {
            handleMemberObjectGroup(1);
          }
        } else {
          handleMemberObjectGroup(formattedSurveyInfomation?.objectGroup);
        }

        setInfomationTabUpdate(true);
        if (!resSurveyMainInfo.peopleInfo) return;
        const infoDisplayed =
          resSurveyMainInfo.surveyObject === 1
            ? state.employeeInfoDisplayed
            : state.customerInfoDisplayed;
        const surveyInfoDisplayed = Object.keys(infoDisplayed).reduce((acc, val) => {
          return {
            ...acc,
            [val]: resSurveyMainInfo.peopleInfo?.includes(objectSurveyPeopleByNumber[val])
              ? true
              : false,
          };
        }, {});
        handleEditUserInfoDisplayedInfo({
          infoDisplayed: surveyInfoDisplayed,
          type:
            resSurveyMainInfo.surveyObject === 1
              ? SurveyConst.EMPLOYEE_INFO
              : SurveyConst.CUSTOMER_INFO,
        });
        const isViewPeopleInfo = Boolean(resSurveyMainInfo.peopleInfo);
        handleSwitchIsPersonDisplayed(isViewPeopleInfo);
      }
    } catch (error: any) {
      if (error?.response.data?.StatusCode === 404) {
        errorNotification(SURVEY_NOT_FOUND);
        setTimeout(() => {
          navigate(`${ROOT}${SURVEY_LIST_PATH}`);
        }, 1500);
        return;
      }
      messageError(error.response, errorNotification);
    }
  };

  const fetchDataMemberList = async () => {
    try {
      if (isOrgUnitMemberSurvey(state.surveyInformation)) {
        // GSURVEY-732: danh sách do OrgUnitMemberProvider tải (memberGroups / orgUnitStaffs)
        return;
      }
      if (
        state.surveyInformation.surveyType === surveyTypeConstant.survey360 &&
        state.isMemberList360Changed
      ) {
        // survey type  360 -> call load data first time and when will the 360 member list change
        await fetchDetailMemberList(
          state.surveyInformation.surveyID,
          state.surveyInformation.objectGroup,
          state.surveyInformation.surveyType,
          state.surveyInformation
        );
        return;
      }
      if (
        state.surveyInformation.surveyType === surveyTypeConstant.normal &&
        state.isFirstLoadTab.memberList
      ) {
        //survey type  normal -> only call load data once time
        handleSetIsFirstLoadTab({
          ...state.isFirstLoadTab,
          memberList: false,
        });
        await fetchDetailMemberList(
          state.surveyInformation.surveyID,
          state.surveyInformation.objectGroup,
          state.surveyInformation.surveyType,
          state.surveyInformation
        );
      }
    } catch (error: any) {
      messageError(error.response, errorNotification);
    }
  };

  const fetchDDLMemberGroup = useCallback(async () => {
    try {
      setLoadingOn();
      const params = {
        ...memberGroupRequest,
        keySearch: '',
        surveyID: state.surveyInformation.surveyID,
      };
      const regionReq = getDDLRegionGroupApi(params);
      const unitReq = getDDLUnitGroupApi(params);
      const departmentReq = getDDLDepartmentGroupApi(params);
      const divisionReq = getDDLDivisionGroupApi(params);
      const restaurantReq = getDDLRestaurantGroupApi(params);
      const positionReq = getDDLPositionGroupApi(params);
      const levelReq = getDDLLevelGroupApi(params);
      const [regionRes, unitRes, departmentRes, divisionRes, restaurantRes, positionRes, levelRes] =
        await Promise.all([
          regionReq,
          unitReq,
          departmentReq,
          divisionReq,
          restaurantReq,
          positionReq,
          levelReq,
        ]);

      const newMemberGroupInfo = {
        regionGroup: {
          ...state.memberGroupInfo.regionGroup,
          requestInfo: {
            ...params,
          },

          responseInfo: {
            page: regionRes.page,
            pageSize: regionRes.pageSize,
            totalItem: regionRes.totalItem,
            totalPage: regionRes.totalPage,
          },
        },
        unitGroup: {
          ...state.memberGroupInfo.unitGroup,
          requestInfo: {
            ...params,
          },
          responseInfo: {
            page: unitRes.page,
            pageSize: unitRes.pageSize,
            totalItem: unitRes.totalItem,
            totalPage: unitRes.totalPage,
          },
        },
        departmentGroup: {
          ...state.memberGroupInfo.departmentGroup,
          requestInfo: {
            ...params,
          },
          responseInfo: {
            page: departmentRes.page,
            pageSize: departmentRes.pageSize,
            totalItem: departmentRes.totalItem,
            totalPage: departmentRes.totalPage,
          },
        },
        divisionGroup: {
          ...state.memberGroupInfo.divisionGroup,
          requestInfo: {
            ...params,
          },
          responseInfo: {
            page: divisionRes.page,
            pageSize: divisionRes.pageSize,
            totalItem: divisionRes.totalItem,
            totalPage: divisionRes.totalPage,
          },
        },
        restaurantGroup: {
          ...state.memberGroupInfo.restaurantGroup,
          requestInfo: {
            ...params,
          },
          responseInfo: {
            page: restaurantRes.page,
            pageSize: restaurantRes.pageSize,
            totalItem: restaurantRes.totalItem,
            totalPage: restaurantRes.totalPage,
          },
        },
        positionGroup: {
          ...state.memberGroupInfo.positionGroup,
          requestInfo: {
            ...params,
          },
          responseInfo: {
            page: positionRes.page,
            pageSize: positionRes.pageSize,
            totalItem: positionRes.totalItem,
            totalPage: positionRes.totalPage,
          },
        },
        levelGroup: {
          ...state.memberGroupInfo.levelGroup,
          requestInfo: {
            ...params,
          },
          responseInfo: {
            page: levelRes.page,
            pageSize: levelRes.pageSize,
            totalItem: levelRes.totalItem,
            totalPage: levelRes.totalPage,
          },
        },
        outlookMail: {
          ...state.memberGroupInfo.outlookMail,
          requestInfo: {
            ...params,
          },
        },
      };
      handleSetMemberGroupInfo(newMemberGroupInfo);
      setDdlQuestionRegionsGroup(regionRes.data);
      setDdlQuestionUnitGroup(unitRes.data);
      setDdlDepartmentGroup(departmentRes.data);
      setDdlDivisionGroup(divisionRes.data);
      setDdlQuestionLevelGroup(levelRes.data);
      setDdlQuestionPositionGroup(positionRes.data);
      setDdlRestaurantGroup(restaurantRes.data);
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  }, [state.surveyInformation.surveyID, JSON.stringify(state.memberGroupInfo)]);

  const fetchTab2Data = async () => {
    try {
      const p1 = getDDLQuestionTypesApi(true); // true: hidden Một đáp án - Câu hỏi 360
      const p2 = getDDLQuestionGroupsApi();
      const [rs1, rs2] = await Promise.all([p1, p2]);

      setDdlQuestionTypes(rs1);
      setDdlQuestionGroups(rs2);
    } catch (error: any) {
      messageError(error.response, errorNotification);
    }
  };

  const fetchTab3DataGroup = async () => {
    if (
      ddlQuestionUnitGroup.length > 0 ||
      ddlDepartmentGroup.length > 0 ||
      ddlRegionGroup.length > 0 ||
      ddlQuestionUnitGroup.length > 0
    )
      return;
    setLoadingOn();

    try {
      const p3 = getDDLQuestionRegionApi({
        surveyID: state.surveyInformation.surveyID ? state.surveyInformation.surveyID : null,
        selectRegionIDs: [],
      });
      const p4 = getDDLQuestionUsersApi();
      const p5 = getDDLQuestionLevelsApi({
        surveyID: state.surveyInformation.surveyID ? state.surveyInformation.surveyID : null,
        selectLevelIDs: [],
      });
      const p7 = getDDLQuestionUnitsApi({
        regions: [],
        selectUnitIDs: [],
      });

      const [rs3, rs4, rs5, rs7] = await Promise.all([p3, p4, p5, p7]);

      setDdlQuestionRegionsGroup(rs3);
      setDdlQuestionLevelGroup(rs5);
      //fetch unit for tab group
      setDdlQuestionUnitGroup(rs7);

      const department = await getDDLQuestionDepartmentApi({
        units: [],
        selectDepartmentIDs: [],
      });
      setDdlDepartmentGroup(department);

      const rs9 = await getDDLDivisionApi({
        departments: [],
        selectDivisionIDs: [],
      });
      setDdlDivisionGroup(rs9);

      const rs10 = await getDDLRestaurantApi({
        page: 1,
        pageSize: 20,
        divisions: [],
        restaurantName: '',
        surveyID: state.surveyInformation.surveyID ? state.surveyInformation.surveyID : null,
        restaurantDtos: [],
      });
      setDdlRestaurantGroup(rs10);
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  };

  const fetchTab3Data = async () => {
    await fetchTab3DataMember();
  };

  const handleFormatQuestionReports = (questionData: ISingleQuestionReport[]) => {
    const formattedQuestion = questionData.filter(
      (x) => x.questionTypeID !== mappingSelectType.evaluated
    );
    return formattedQuestion;
  };

  const fetchTab4Data = async () => {
    if (!state.surveyInformation.surveyID) return;
    setLoadingOn();
    try {
      const { questionsReports: qRs, feedBack } = await getSurveyResults(
        state.surveyInformation.surveyID
      );
      if (qRs) {
        const formatQuestionsReports = handleFormatQuestionReports(qRs);
        setQuestionsReports(formatQuestionsReports);
      }
      if (feedBack) {
        setSurveyTotalStatistics(feedBack);
      }
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  };

  const fetchTab5Data = async () => {
    if (!state.surveyInformation.surveyID) return;
    setLoadingOn();
    try {
      const res1 = getSurveyTotalStatistics(state.surveyInformation.surveyID);
      const res2 = getNumberPeopleDoNotSurvey(state.surveyInformation.surveyID);
      const res3 = createLinkSurvey(state.surveyInformation.surveyID);
      const [rs1, rs2, rs3] = await Promise.all([res1, res2, res3]);
      setSurveyTotalStatistics(rs1);
      setNumberPeopleDoNotSurvey(rs2);
      setHashCode(rs3);
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  };

  const handleUpdateQuestion = async () => {
    if (!state.isFetchQuestionAfterUploadExcel && !state.surveyDataSaveTab.groupQuestions) {
      const evaluatedQuestion = findQuestionArrByField(
        state.groupQuestions,
        mappingSelectType.evaluated,
        'questionTypeID'
      );
      if (state.surveyTypeForm === 1 && evaluatedQuestion && evaluatedQuestion.length > 0) {
        handleRemoveQuestionInGroup(
          SurveyConst.INIT_GROUP_QUESTION,
          evaluatedQuestion[0].questionID
        );
      }

      const formattedParameter = transformGroupQuestionsToParentQuestions();

      if (!formattedParameter) return;

      const surveyQuestionFnc = isContentTabUpdate
        ? updateSurveyAddQuestionApi
        : postSurveyAddQuestionApi;
      try {
        await surveyQuestionFnc(formattedParameter);
      } catch (error: any) {
        messageError(error.response, errorNotification);
      }
    }
  };

  const handleLoadQuestionData = async () => {
    if (state.isFirstLoadTab.content) {
      handleSetIsFirstLoadTab({
        ...state.isFirstLoadTab,
        content: false,
      });
      await fetchSurveyQuestionByID();
      return;
    }
    const formatGroupQuestions = await handleLogicEvaluatedQuestion(state.groupQuestions);
    handleAddGroupQuestion(formatGroupQuestions);
  };

  const handleFetchInformationTab = async () => {
    try {
      setLoadingOn();
      const reqDDL = fetchInformationTabDDLData();
      const reqFetchFormData = fetchDataWhenEditing();
      await Promise.all([reqDDL, reqFetchFormData]);
    } finally {
      setLoadingOff();
    }
  };

  const handleFetchMemberListTab = async () => {
    try {
      setLoadingOn();
      const reqDDL = fetchTab3Data();
      const reqTableList = fetchDataMemberList();
      await Promise.all([reqDDL, reqTableList]);
    } finally {
      setLoadingOff();
    }
  };

  const handleFetchContentTab = async () => {
    try {
      setLoadingOn();
      const reqDDL = fetchTab2Data();
      const reqQuestions = handleLoadQuestionData();
      await Promise.all([reqDDL, reqQuestions]);
    } finally {
      setLoadingOff();
    }
  };

  const handleFetchPreviewSurveyTab = async () => {
    try {
      setLoadingOn();
      if (state.isFirstLoadTab.content) {
        handleSetIsFirstLoadTab({
          ...state.isFirstLoadTab,
          content: false,
        });
        await fetchSurveyQuestionByID();
      }
    } catch (error: any) {
      messageError(error.response, errorNotification);
    } finally {
      setLoadingOff();
    }
  };

  useEffect(() => {
    switch (state.currentTab) {
      case 'information': {
        once(handleFetchInformationTab)();
        break;
      }

      case 'content': {
        once(handleFetchContentTab)();
        break;
      }

      case 'memberList': {
        once(handleFetchMemberListTab)();
        break;
      }

      case 'surveyResult': {
        once(fetchTab4Data)();
        break;
      }

      case 'release': {
        once(fetchTab5Data)();
        break;
      }

      case 'reviewSurvey': {
        once(handleFetchPreviewSurveyTab)();
        break;
      }

      default:
        break;
    }
  }, [state.currentTab]);

  return (
    <SurveyContext.Provider
      value={{
        ...state,
        isViewSurvey: state.isViewSurvey || isLockReadOnly,
        isViewRoute: state.isViewSurvey,
        handleSetLockReadOnly: setIsLockReadOnly,
        handleEditUserInfoDisplayedInfo,
        handleOpenModal,
        handleCloseModal,
        handleSwitchIsPersonDisplayed,
        handleAddQuestion,
        ddlQuestionUsers,
        ddlQuestionTypes,
        ddlQuestionGroups,
        ddlDepartment,
        ddlEmbedApp,
        ddlRegion,
        ddlQuestionUnit,
        ddlQuestionPosition,
        ddlQuestionLevel,
        ddlStaff,
        ddlDivision,
        ddlRestaurant,
        ddlOutlook,
        ddlRegionGroup,
        ddlQuestionUnitGroup,
        ddlDepartmentGroup,
        ddlQuestionPositionGroup,
        ddlQuestionLevelGroup,
        ddlDivisionGroup,
        ddlRestaurantGroup,
        updateDDlStaff: handleDdlStaff,
        updateDDlDepartment: handleDdlDepartment,
        updateDdlQuestionUnit: handleDdlQuestionUnit,
        updateDdlGroupDivision: handleDdlGroupDivision,
        updateDdlGroupRestaurant: handleDdlGroupRestaurant,
        updateDdlGroupLevelGroup: handleUpdateDdlLevelGroup,
        updateDdlOutlook: handleDdlOutlook,
        updateDDlDepartmentGroup: handleDdlDepartmentGroup,
        updateDdlQuestionUnitGroup: handleDdlQuestionUnitGroup,
        updateDdlGroupDivisionGroup: handleDdlGroupDivisionGroup,
        updateDdlGroupRestaurantGroup: handleDdlGroupRestaurantGroup,
        updateDdlGroupPositionGroup: handleUpdateDdlPositionGroup,
        updateDdlGroupRegionGroup: handleUpdateDdlRegionGroup,
        listOfUserReview,
        surveyTotalStatistics,
        numberPeopleDoNotSurvey,
        questionsReports,
        hashCode,
        handleAddGroupQuestion,
        handleMoveSectionInGroup,
        handleMoveQuestionInGroup,
        handleRemoveQuestionInGroup,
        handleRemoveSectionInGroup,
        handleSelectQuestionID,
        handleSelectSectionID,
        handleEditSelectQuestionInGroupSection,
        handleSetSurveyInformation,
        handleSetListOfBonusCodes,
        handleSetMemberSearch,
        handleSetMemberGroupFilter,
        handleMemberObjectGroup,
        handleSetMemberList,
        handleSetMemberList360,
        handleSetMemberListSelected,
        handleSetMemberListChosen,
        handleSetMemberListAll,
        handleSetMemberListAll360,
        handleChangeTab,
        handleSavingAllTabs,
        handleSavingAllTabsEnd,
        postSurveyInformation,
        handleInitSurvey,
        handleUpdateAllTabs,
        handleDisabledSurveyEdit,
        handleUpdateQuestionEvaluated,
        closeUploadModalThenUpdatingTab2,
        /**Demo */
        staffsDemo,
        handleLoadMoreStaffsDemo,
        handleSetIsViewSurvey,
        handleSetSkipModalConfirm,
        handleSaveTab,
        handleSetUserChangeModalAddQuestion,
        formatSurveyMemberListSelected,
        handleSetInfoPeople,
        handleSetDisabledSurvey360,
        handleSetSurveyTypeForm,
        handleUpdateQuestion,
        handleSetSurveyDataSave,
        handleSetIsEvaluatedQuestionExist,
        setLoadingOn,
        setLoadingOff,
        handleSetQuestionOrder,
        handleSetMemberGroupInfo,
        fetchDDLMemberGroup,
        handleSetLoadingMemberGroupInfo,
        handleSetActionChangeListMemberGroup,
        handleSetCurrentValueInformationTab,
        handleUpdateDDLRegionGroupBackup,
        handleUpdateDDLUnitGroupBackup,
        handleUpdateDDLDepartmentGroupBackup,
        handleUpdateDDLDivisionGroupBackup,
        handleUpdateDDLRestaurantGroupBackup,
        handleUpdateDDLPositionGroupBackup,
        handleUpdateDDLLevelGroupBackup,
        handleSetListStaff360,
        handleSetFetchQuestionAfterUploadExcel,
        handleSetParamFiltersEvaluatedQuestion,
        handleSetIsMemberList360Changed,
      }}
    >
      <>
        {children}
        {duplicateStaffConflictModal}
      </>
    </SurveyContext.Provider>
  );
};

export const useSurveyContext = () => {
  return useContext(SurveyContext);
};

export { SurveyProvider };
